<template>
  <DxPopup
    :visible="getVisible"
    @hidden="onPopupHide"
    :drag-enabled="false"
    :hide-on-outside-click="popupConfig.hideOnOutsideClick"
    :show-close-button="false"
    :show-title="true"
    :width="'99.99%'"
    :height="'99.99%'"
    :title="popupConfig.title"
    :wrapper-attr="wrapperAttr"
    ref="gc-popup"
    @shown="onShown"
    @initialized="onInitialized"
    :fullScreen="false"
  >
    <DxToolbarItem
      v-if="popupConfig.formMode !== 'create' && popupConfig.secondaryTitle"
      location="before"
      :html="`<span class='toolbar-title-secondary text-secondary'> ${popupConfig.secondaryTitle}</span>`"
    ></DxToolbarItem>
    <DxToolbarItem
      v-for="(item, index) in getToolbarItems"
      :key="index"
      :widget="item.widget"
      :location="item.location"
      :visible="item.visible"
      :toolbar="item.position"
      :options="item.options"
      :template="item.template ? item.template : null"
    />

    <template #screen-pdf-view>
      <gcScreenPdfView
        :buttonColor="'#e8f7f9'"
        :screenName="'Work Orders'"
        :onPreviewPDF="onPreviewPDF"
        v-if="IsFormLoaded && popupConfig.formMode === 'review'"
      />
    </template>

    <template #wo-status-template>
      <gc-status-chip :status="FriendlyStatus" v-if="FriendlyStatus" />
    </template>

    <transition name="expand">
      <div
        class="css-v2 gc-popup-form"
        v-if="popupConfig.isPopupShow"
        v-show="!IsGridExpanded"
      >
        <div
          class="wo-data-header"
          v-bind:class="{ 'core-instance': WorkOrderInstance === 'Core' }"
        >
          <div class="section-1">
            <gc-form
              :key="popupConfig.formKey"
              :form-options="{
                gcLabelLocation: 'left',
              }"
              ref="gc-header-form"
              :form-items="getHeaderFormItems"
              :is-normal="true"
              :data-model="model"
              :form-mode="popupConfig.formMode"
              :from-from="'gc-header-form-d-a'"
              :form-height="280"
              v-if="IsFormLoaded"
            />
          </div>
          <div class="section-2">
            <dx-data-grid
              @toolbar-preparing="onToolbarPreparing($event)"
              :columnChooser="{
                enabled: false,
              }"
              :pager="{ visible: false }"
              :columns="getHeaderSection2Columns"
              :data-source="getHeaderSection2DataSource"
              :row-alternation-enabled="true"
              :repaint-changes-only="true"
              :show-borders="true"
              :two-way-binding-enabled="false"
              :height="320"
              @cell-prepared="onHeaderSection2CellPrepared"
              ref="header-section-2-grid"
            >
            </dx-data-grid>
          </div>
          <div class="section-3">
            <dx-data-grid
              @toolbar-preparing="onToolbarPreparing($event)"
              :columnChooser="{
                enabled: false,
              }"
              :pager="{ visible: false }"
              :columns="getHeaderSection3Columns"
              :data-source="getHeaderSection3DataSource"
              :row-alternation-enabled="true"
              :repaint-changes-only="true"
              :show-borders="true"
              :two-way-binding-enabled="false"
              :height="WorkOrderInstance === 'Almondco' ? 320 : 'auto'"
              @cell-prepared="onHeaderSection3CellPrepared"
              ref="header-section-3-grid"
            >
            </dx-data-grid>
            <dx-data-grid
              v-if="WorkOrderInstance === 'Core'"
              @toolbar-preparing="onToolbarPreparing($event)"
              :columnChooser="{
                enabled: false,
              }"
              :pager="{ visible: false }"
              :columns="getHeaderSection3Part2Columns"
              :data-source="getHeaderSection3Part2DataSource"
              :row-alternation-enabled="true"
              :repaint-changes-only="true"
              :show-borders="true"
              :two-way-binding-enabled="false"
              :height="WorkOrderInstance === 'Almondco' ? 320 : 105"
              ref="header-section-3-grid"
              :element-attr="{
                class: 'header-section-3-part2-grid',
              }"
              @cell-prepared="onHeaderSection3Part2CellPrepared"
            >
            </dx-data-grid>
          </div>
        </div>

        <gc-form
          :key="popupConfig.formKey"
          :form-options="{
            gcLabelLocation: 'top',
          }"
          ref="gc-header-form-comment"
          :form-items="getHeaderComment"
          :is-normal="true"
          :data-model="model"
          :form-mode="popupConfig.formMode"
          :from-from="'gc-header-form-d-a'"
          :form-height="110"
          v-if="IsFormLoaded"
        />
      </div>
    </transition>

    <div style="background-color: white" class="wo-data-details">
      <DxToolbar class="wo-so-toolbar" v-if="IsFormLoaded">
        <DxItem
          :options="{
            width: 'auto',
            dataSource: getTabViews,
            selectedIndex: selectedTabIndex,
            onItemClick: handleTabClick,
          }"
          location="before"
          widget="dxTabs"
        />

        <DxItem
          :options="{
            icon: IsGridExpanded ? 'collapse' : 'expand',
            text: '',
            elementAttr: {
              class: 'expand-btn',
            },
            onClick: onExpandGrid,
          }"
          location="after"
          locate-in-menu="auto"
          widget="dxButton"
        />

        <DxItem
          :options="{
            icon: 'plus',
            text: 'Add New',
            elementAttr: {
              class: 'add-new-btn',
            },
            width: '130',
            items: getAddNewOptions,
            dropDownOptions: {
              minWidth: 150,
            },
          }"
          location="after"
          locate-in-menu="auto"
          widget="dxDropDownButton"
          :visible="getAddNewOptions.find((x) => x.visible) ? true : false"
        />
      </DxToolbar>

      <div class="wo-so-lines">
        <!-- MTS Grid  -->
        <dx-data-grid
          v-if="
            IsFormLoaded && selectedTabIndex === getTabIndex('Make to Stock')
          "
          @toolbar-preparing="onToolbarPreparing($event)"
          :columnChooser="{
            enabled: false,
          }"
          :key-expr="'ID'"
          :pager="{ visible: false }"
          :columns="getMTSGridColumns"
          :data-source="getMTSDataSource"
          :row-alternation-enabled="true"
          :repaint-changes-only="true"
          :show-borders="true"
          :two-way-binding-enabled="false"
          :focusedRowEnabled="true"
          :height="gridHeight"
          :ref="'mts-grid'"
          @editor-preparing="onEditorPreparing"
          @saved="onSaved"
          @row-removed="onRowRemoved"
          @content-ready="onContentReady"
        >
          <DxEditing
            :allow-deleting="popupConfig.formMode != 'review'"
            :allow-updating="popupConfig.formMode != 'review'"
            :mode="'cell'"
            :changes="changes"
          />

          <DxRowDragging
            :allow-reordering="popupConfig.formMode !== 'review'"
            :show-drag-icons="true"
            :on-reorder="onRowReorder"
          />
          <template #Record="{ data }">
            <GcRecord
              :data="data"
              :primary="data.column['cellTemplateRecord']['primary']"
              :secondary="data.column['cellTemplateRecord']['secondary']"
            />
          </template>

          <template #Decimal="{ data }">
            <GcDecimal :dataValue="data" :format="data.column.format" />
          </template>
        </dx-data-grid>
        <!-- Add Ins Grid  -->
        <dx-data-grid
          v-if="
            IsFormLoaded &&
            selectedTabIndex === getTabIndex('Add In') &&
            IsAddInFeatureEnabled
          "
          @toolbar-preparing="onToolbarPreparing($event)"
          :columnChooser="{
            enabled: false,
          }"
          :key-expr="'ID'"
          :pager="{ visible: false }"
          :columns="getAddInGridColumns"
          :data-source="getAddInLocalDataSource"
          :row-alternation-enabled="true"
          :height="gridHeight"
          :ref="'wo-add-in-grid'"
          @selection-changed="onAddInSelectionChanged"
          @content-ready="onContentReady"
          @editor-preparing="onEditorPreparing"
          @row-updated="addInRowUpdated"
          @initialized="onGridInitialized"
        >
          <DxEditing
            :allow-deleting="popupConfig.formMode != 'review'"
            :allow-updating="popupConfig.formMode != 'review'"
            :mode="'cell'"
            :changes="changes"
          />
          <!-- <DxRowDragging
            :allow-reordering="popupConfig.formMode !== 'review'"
            :show-drag-icons="true"
            :on-reorder="onRowReorder"
          />-->
          <template #Record="{ data }">
            <GcRecord
              :data="data"
              :primary="data.column['cellTemplateRecord']['primary']"
              :secondary="data.column['cellTemplateRecord']['secondary']"
            />
          </template>

          <template #Decimal="{ data }">
            <GcDecimal :dataValue="data" :format="data.column.format" />
          </template>
        </dx-data-grid>

        <!-- Sale Orders Grid  -->
        <dx-data-grid
          v-if="IsFormLoaded"
          v-show="selectedTabIndex === getTabIndex('Sales Orders')"
          @toolbar-preparing="onToolbarPreparing($event)"
          :columnChooser="{
            enabled: false,
          }"
          :pager="{ visible: false }"
          :columns="getSalesGridColumns"
          :data-source="getLocalDataSource"
          :row-alternation-enabled="true"
          :selection="{
            mode: getAddSOLineBtnVisibility ? 'multiple' : 'none',
          }"
          :height="gridHeight"
          :ref="'wo-so-line-grid'"
          @selection-changed="onSoListSelectionChanged"
          @content-ready="onContentReady"
          @editor-preparing="onEditorPreparing"
          @row-updated="addInRowUpdated"
          @initialized="onGridInitialized"
        >
          <DxEditing
            :allow-deleting="false"
            :allow-updating="popupConfig.formMode != 'review'"
            :mode="'cell'"
            :changes="changes"
          />
          <DxRowDragging
            :allow-reordering="popupConfig.formMode !== 'review'"
            :show-drag-icons="true"
            :on-reorder="onRowReorder"
          />
          <template #Record="{ data }">
            <GcRecord
              :data="data"
              :primary="data.column['cellTemplateRecord']['primary']"
              :secondary="data.column['cellTemplateRecord']['secondary']"
            />
          </template>
          <template #Status="{ data }">
            <GcStatusChip
              :status="data.data[data.column.dataField]"
              v-if="data.data[data.column.dataField]"
              :customBackGroundColor="
                data.column.customBackGroundColor
                  ? data.column.customBackGroundColor
                  : undefined
              "
              :data="data.data"
            />
          </template>

          <template #Decimal="{ data }">
            <GcDecimal :dataValue="data" :format="data.column.format" />
          </template>
        </dx-data-grid>

        <!-- Processes Grid  -->
        <gcWorkOrderProcessesTab
          v-show="IsFormLoaded && selectedTabIndex === getTabIndex('Processes')"
          v-if="popupConfig.formMode !== 'create'"
          :dataModel="getDataModelForIssuesTab"
          :height="gridHeight"
          :displayServerError="displayServerError"
          :showLoading="showLoading"
          :ref="'process-tab-grid-component'"
          :popup-mode="popupConfig.formMode"
          @setFocusOnField="setFocusOnField"
          @onProcessTabEditingStart="onProcessTabEditingStart"
          :refreshOnUpdate="refreshOnUpdate"
          :selectedTabIndex="selectedTabIndex === getTabIndex('Processes')"
        />

        <!-- Scheduling Tab -->
        <gcWorkOrderSchedulingTab
          v-show="IsFormLoaded && selectedTabIndex === getTabIndex('Schedule')"
          v-if="IsFormLoaded && popupConfig.formMode !== 'create'"
          :height="gridHeight"
          :displayServerError="displayServerError"
          :showLoading="showLoading"
          :dataModel="getDataModelForIssuesTab"
          :popup-mode="popupConfig.formMode"
          :ref="'scheduling-tab-grid-component'"
          @setFocusOnField="setFocusOnField"
          :isEditable="isScheduleTabEditable"
          :shiftSchedules="shiftSchedules"
          :isVisibleNow="selectedTabIndex === getTabIndex('Schedule')"
        />

        <!-- Materials Grid  -->
        <gcWorkOrderMaterialsTab
          v-show="IsFormLoaded && selectedTabIndex === getTabIndex('Materials')"
          v-if="popupConfig.formMode !== 'create'"
          :dataModel="getDataModelForIssuesTab"
          :height="gridHeight"
          :displayServerError="displayServerError"
          :showLoading="showLoading"
          :ref="'materials-tab-grid-component'"
          :popup-mode="popupConfig.formMode"
          @setFocusOnField="setFocusOnField"
          :refreshOnUpdate="refreshOnUpdate"
        />

        <!-- Time Grid  -->
        <dx-data-grid
          v-if="IsFormLoaded && selectedTabIndex === getTabIndex('Time')"
          @toolbar-preparing="onToolbarPreparing($event)"
          :columnChooser="{
            enabled: false,
          }"
          :pager="{ visible: false }"
          :columns="getWorkOrderTimeColumns"
          :data-source="workOrderTimeDataSource"
          :row-alternation-enabled="true"
          :selection="{
            mode: 'none',
          }"
          :height="gridHeight"
          :ref="'wo-time-grid'"
          @editor-preparing="onEditorPreparing"
          @content-ready="onContentReady"
        >
          <DxEditing
            :allow-updating="popupConfig.formMode != 'review'"
            :mode="'cell'"
            :changes="changes"
          />
          <template #Decimal="{ data }">
            <GcDecimal :dataValue="data" :format="data.column.format" />
          </template>
        </dx-data-grid>

        <!-- Issues Grid -->
        <gcWorkOrderIssuesTab
          v-if="IsFormLoaded && selectedTabIndex === getTabIndex('Issues')"
          :dataModel="getDataModelForIssuesTab"
          :height="gridHeight"
          :displayServerError="displayServerError"
          :showLoading="showLoading"
          :ref="'issues-tab-grid-component'"
          @onRefreshDataList="onRefreshDataList"
          @onRefreshWorkOrderHeader="onRefreshWorkOrderHeader"
        />

        <!-- Release Grid  -->
        <dx-data-grid
          v-if="IsFormLoaded && selectedTabIndex === getTabIndex('Releases')"
          @toolbar-preparing="onToolbarPreparing($event)"
          :columnChooser="{
            enabled: false,
          }"
          :pager="{ visible: false }"
          :columns="getReleaseColumns"
          :data-source="ReleaseDataSource"
          :row-alternation-enabled="true"
          :selection="{
            mode: 'none',
          }"
          :height="gridHeight"
          :ref="'wo-release-grid'"
          @content-ready="onContentReady"
        >
          <DxScrolling
            :mode="'virtual'"
            :row-rendering-mode="'virtual'"
            :preload-enabled="true"
          />
          <template #Record="{ data }">
            <GcRecord
              :data="data"
              :primary="data.column['cellTemplateRecord']['primary']"
              :secondary="data.column['cellTemplateRecord']['secondary']"
            />
          </template>

          <template #Decimal="{ data }">
            <GcDecimal :dataValue="data" :format="data.column.format" />
          </template>

          <template #product-um-template="{ data }">
            <div v-if="data.value > 0">
              <a @click="onProdQtyClicked(data)">{{ data.text }}</a>
            </div>
            <div v-else-if="data.value < 0" class="hyperlink negative">
              <a @click="onProdQtyClicked(data)">{{ data.text }}</a>
            </div>
            <div v-else class="hyperlink zero">
              <a @click="onProdQtyClicked(data)">-</a>
            </div>
          </template>
        </dx-data-grid>
      </div>
    </div>

    <GcPopupAudit
      v-if="popupAuditVisible"
      :showPopup.sync="popupAuditVisible"
      :model.sync="auditModel"
    />

    <gcPopupWorkOrderSoLinesVue
      :popupConfig="soPopupConfig"
      :add-selected-so-lines="addSelectedSoLines"
      :pre-selected-items="soLinesDataSource._array"
      v-if="soPopupConfig.visible"
    />

    <gcPopupWorkOrderReleaseInfo
      :popupConfig="releasePopupInfo"
      :onHide="releasePopupHide"
      :displayServerError="displayServerError"
      :showLoading="showLoading"
      @onRefreshDataList="onRefreshDataList"
      @onRefreshWorkOrderHeader="onRefreshWorkOrderHeader"
      v-if="releasePopupInfo.isPopupShow"
    />

    <gcPopupReleaseModel
      :popupConfig="releaseModelInfo"
      :onHide="releasePopupHide"
      v-if="releaseModelInfo.isPopupShow"
      :showLoading="showLoading"
      @onRefreshDataList="onRefreshDataList"
      @onRefreshWorkOrderHeader="onRefreshWorkOrderHeader"
    />

    <GcPopupMaterialIssue
      :popupConfig="issueModelInfo"
      :on-hide="materialPopupHide"
      v-if="issueModelInfo.isPopupShow"
      :showLoading="showLoading"
      @onRefreshDataList="onRefreshDataList"
      @onRefreshWorkOrderHeader="onRefreshWorkOrderHeader"
      :popup-mode="issueModelInfo.popupMode"
    />

    <gcPopupReleaseAndIssueBulk
      :popupConfig="bulkPopupConfig"
      :showLoading="showLoading"
      :isPopupShow="bulkPopupConfig.isPopupShow"
      @update:isPopupShow="bulkPopupConfig.isPopupShow = $event"
      v-if="bulkPopupConfig.isPopupShow"
      @onRefreshDataList="onRefreshDataList"
      @onRefreshWorkOrderHeader="onRefreshWorkOrderHeader"
      :on-hide="materialPopupHide"
    />
  </DxPopup>
</template>
<script>
import { TransactionReportService } from "@/_services/api/reports/transaction-report.service";
import ApiService from "@/_services/api/api.service";
import { getGlobalField } from "@/_store/helpers";
import { b64toBlob } from "@/_helpers/pdf/pdf-helper";

import { WorkOrderService } from "../../_services/api/production/work-order.service";
import { UserService } from "../../_services/api/settings/user/user.service";
import SettingsService from "../../_services/api/settings/graycorp/settings.service";
import { DefaultCompanyBranchDivisionService } from "../../_services/api/sales/default-company-branch-dicision.service";
import { FeatureStorage } from "../../_services/storage";
import { mapGetters } from "vuex";
import gcPopupWorkOrderSoLinesVue from "./gc-popup-work-order-so-lines.vue";
import ArrayStore from "devextreme/data/array_store";
import DataGridMixin from "@/_mixins/data-grid.mixin";
import ColumnWidth from "../../_helpers/data-grid/ColumnWidth";
import { DxRowDragging } from "devextreme-vue/data-grid";
import gcPopupWorkOrderReleaseInfo from "./gc-popup-work-order-release-info";
import gcPopupReleaseModel from "./gc-popup-release-model";

import salesFormulas from "../../_helpers/formulas/sales-formulas";
import { ProductService } from "../../_services/api/products/product.service";
const { calculateStockUMQty, calculateSalesUMQty } = salesFormulas;
import gcWorkOrderIssuesTab from "../../components/production/work-order/issues-tab.vue";
import gcWorkOrderProcessesTab from "../../components/production/work-order/processes-tab.vue";
import gcWorkOrderMaterialsTab from "../../components/production/work-order/materials-tab.vue";
import gcWorkOrderSchedulingTab from "../../components/production/work-order/scheduling-tab.vue";
import GcPopupMaterialIssue from "./gc-popup-material-issue .vue";
import { formatNumber } from "devextreme/localization";

import gcScreenPdfView from "../../components/common/gc-screen-pdf-view.vue";
import { backwardTabbing, forwardTabbing } from "../../_helpers/ui/keyboard";
import { getSortSettingsFromCombinedSetting } from "../../_helpers/views/work-order";

import gcPopupReleaseAndIssueBulk from "./gc-popup-release-and-issue-bulk.vue";
import { IsResponseDataValid } from "../../_helpers/ui/helpers";

const productEntryBase = {
  ID: 0,
  ItemCode: "",
  Description: "",
  SalesUM: "",
  StockUM: "",
  OnHand: 0,
  AddInStockUMQty: 0,
  IsSelected: false,
  OnHandSalesUMQty: 0,
  AddInSalesUMQty: 0,
  SalesUMConversion: 1,
  Available: 0,
  AvailableSalesUMQty: 0,
  OriginalAvailable: 0,
  OriginalAvailableSalesUMQty: 0,
  Note: "",
  StockUMQuantity: 0,
  IsDeletable: "Y",
};

function countLineBreaks(text) {
  return (text.match(/\n/g) || []).length;
}

const defaultProductionSummary = () => ({
  AddInProductionUMQty: 0.0,
  AddInStockUMQty: 0.0,
  MTSProductionMQty: 0.0,
  MTSStockUMQty: 0.0,
  ReleasedProductionUMPercent: 0.0,
  ReleasedProductionUMQty: 0.0,
  ReleasedStockUMPercent: 0.0,
  ReleasedStockUMQty: 0.0,
  SalesOrderProductionUMQty: 0.0,
  SalesOrderStockUMQty: 0.0,
  WorkOrderProductionUMQty: 0.0,
  WorkOrderStockUMQty: 0.0,
  ProductionUM: "",
  StockUM: "",
  VarianceStockUMPercent: 0.0,
  VarianceStockUMQty: 0.0,
  SendToProductionStockUMQty: 0.0,
  SendToProductionProductionUMQty: 0.0,
  VarianceProductionUMQty: 0.0,
  VarianceProductionUMPercent: 0.0,
});

const defaultMaterialSummary = () => ({
  BiProduct: 0.0,
  BiProductPercent: 0.0,
  LossGainPercent: 0.0,
  LossGainStockUMQty: 0.0,
  MaterialAddedIn: 0.0,
  MaterialIssued: 0.0,
  MaterialReturned: 0.0,
  BrownReclaimPercent: 0.0,
  BrownReclaimStockUMQty: 0.0,
  WhiteReclaimPercent: 0.0,
  WhiteReclaimStockUMQty: 0.0,
  Rubbish: 0.0,
  StockUM: "",
});

const defaultCostSummary = () => ({
  FullManufacturedActualCost: 0,
  FullManufacturedPlannedCost: 0,
  FullManufacturedVarianceCost: 0,
  FullManufacturedVariancePercent: 0,
  LabourActualCost: 0,
  LabourPlannedCost: 0,
  LabourVarianceCost: 0,
  LabourVariancePercent: 0,
  MaterialsActualCost: 0,
  MaterialsPlannedCost: 0,
  MaterialsVarianceCost: 0,
  MaterialsVariancePercent: 0,
  ProcessCode: "",
  ProductionUMActualCost: 0,
  ProductionUMPlannedCost: 0,
  ProductionUMVarianceCost: 0,
  ProductionUMVariancePercent: 0,
  StockUM: "",
  StockUMActualCost: 0,
  StockUMPlannedCost: 0,
  StockUMVarianceCost: 0,
  StockUMVariancePercent: 0,
  WorkOrderCode: 0,
});

export default {
  mixins: [DataGridMixin],
  components: {
    gcPopupWorkOrderSoLinesVue,
    DxRowDragging,
    gcPopupWorkOrderReleaseInfo,
    gcPopupReleaseModel,
    gcWorkOrderIssuesTab,
    GcPopupMaterialIssue,
    gcScreenPdfView,
    gcWorkOrderProcessesTab,
    gcWorkOrderMaterialsTab,
    gcPopupReleaseAndIssueBulk,
    gcWorkOrderSchedulingTab,
  },
  data() {
    return {
      popupAuditVisible: false,
      auditModel: {
        createdBy: "",
        dateCreated: "",
        changedBy: "",
        dateChanged: "",
      },
      FriendlyStatus: "Draft",
      model: {
        BomCode: null,
        Branch: null,
        QuoteCode: 0,
        Code: 0,
        Comments: "",
        CompanyCode: "",
        Division: null,
        Product: null,
        Quantity: 0,
        Required: new Date(),
        Scheduled: new Date(),
        DateIn: new Date(),
        MTSQuantity: 0,
        SOQuantity: 0,
        ReleasedQty: 0,
        AddInSalesUMQuantity: 0,
        AddInStockUMQuantity: 0,
        ReleaseDepartment: null,
        SchedulingMethod: null,
      },
      AddInSalesUM: "KG",
      AddInSalesUMConversion: 1,
      AddInStockUM: "KG",
      IsAddInFeatureEnabled: false,
      IsTimeFeatureEnabled: false,
      IsFormLoaded: false,
      soPopupConfig: {
        visible: false,
      },
      bulkPopupConfig: {
        isPopupShow: false,
        dataModel: {},
      },
      mtsDataSource: new ArrayStore({
        key: "ID",
        data: [],
      }),
      soLinesDataSource: new ArrayStore({
        key: ["SalesOrderCode", "SalesOrderLine"],
        data: [],
      }),
      addInDataSource: new ArrayStore({
        key: "ID",
        data: [],
      }),
      workOrderTimeDataSource: new ArrayStore({
        key: ["Code"],
        data: [],
      }),
      selectedRowsData: [],
      selectedBOMData: undefined,
      selectedProdData: undefined,
      primaryProductData: undefined,
      selectedTabIndex: 0,
      changes: [],
      addInProdFilter: [],
      productDataSourceItems: [],
      WorkOrderAddInFinishedGoodType: undefined,
      WorkOrderAddInFinishedGoodAssociation: undefined,
      saveAsDraft: false,
      releasePopupInfo: {
        isPopupShow: false,
        dataModel: {},
      },
      RetainMTSLinesOnCopy: "N",
      Status: "D",
      StatusDataSource: [],
      releaseModelInfo: {
        isPopupShow: false,
        dataModel: {
          BranchCode: undefined,
          ReleaseDate: new Date(),
          WorkOrderCode: undefined,
        },
      },
      HotKeyWatcherEnabled: true,
      WorkOrderInstance: "Core",
      issueModelInfo: {
        isPopupShow: false,
        dataModel: {
          BranchCode: undefined,
          IssueDate: new Date(),
          WorkOrderCode: undefined,
        },
        popupMode: "create",
      },
      StatusComponent: null,
      headerSection2DataSource: new ArrayStore({
        key: "ID",
        data: [],
      }),
      headerSection3DataSource: new ArrayStore({
        key: "ID",
        data: [],
      }),
      headerSection3Part2DataSource: new ArrayStore({
        key: "ID",
        data: [],
      }),
      gridHeight: "auto",

      ProductionSummary: defaultProductionSummary(),
      MaterialSummary: defaultMaterialSummary(),
      CostSummary: defaultCostSummary(),
      MTSQuantityForCopy: 0,
      isWorkOrderMaterialsTabVisible: false,
      isWorkOrderProcessesTabVisible: false,
      PrimaryProduct: undefined,
      refreshOnUpdate: false,
      IsBOMDisabled: false,
      IsGridExpanded: false,

      // Track changes for alert conditions
      initialRequiredDate: null,
      isRequiredDateChanged: false,
      initialTotalQuantity: 0,
      isQuantityChanged: false,
      isProcessTabChanged: false,
      shiftSchedules: [],
      setScheduleTabVisible: false,
    };
  },
  props: {
    popupConfig: {
      type: Object,
      default: () => {},
    },
    onToolbarMenuItemOnClick: {
      type: Function,
      default: () => {},
    },
    wrapperAttr: {
      type: Object,
      default: () => {},
    },
    onHide: {
      type: Function,
      default: () => [],
    },
    width: {
      type: Number,
      default: 300,
    },
    height: {
      type: Number,
      default: 600,
    },
    dataModel: {
      type: Object,
      default: () => {},
    },
    applicationFeatureCode: {
      type: String,
      default: "WorkOrder",
    },
    showLoading: {
      type: Function,
      default: () => {},
    },
    saveCallBack: {
      type: Function,
      default: () => {},
    },
    displayServerError: {
      type: Function,
      default: function () {},
    },
    displayValidationSummary: {
      type: Function,
      default: function () {},
    },
  },
  async created() {
    if (this.popupConfig.formMode !== "create") {
      let WorkOrderMaterialsTabSetting =
        await SettingsService.getBySettingNameFromDb("WorkOrderMaterialsTab");
      if (WorkOrderMaterialsTabSetting.data.value.length > 0) {
        this.isWorkOrderMaterialsTabVisible =
          WorkOrderMaterialsTabSetting.data.value[0].SettingValue == "Y";
      }

      let WorkOrderProcessesTabSetting =
        await SettingsService.getBySettingNameFromDb("WorkOrderProcessesTab");
      if (WorkOrderProcessesTabSetting.data.value.length > 0) {
        this.isWorkOrderProcessesTabVisible =
          WorkOrderProcessesTabSetting.data.value[0].SettingValue == "Y";
      }

      const ReleaseViewDefaultSortColumns =
        await getSortSettingsFromCombinedSetting(
          "WOConsolidatedReleaseViewDefaultSortColumns",
          this.getReleaseColumns.map((col) => col.dataField),
        );

      if (ReleaseViewDefaultSortColumns.length > 0) {
        ReleaseViewDefaultSortColumns.forEach((element) => {
          const targetCol = this.getReleaseColumns.find(
            (col) => col.dataField === element.dataField,
          );

          if (targetCol) {
            targetCol.sortOrder = element.sortOrder;
            targetCol.sortIndex = element.sortIndex;
          }
        });
      }
    } else {
      this.isWorkOrderProcessesTabVisible = false;
    }

    let workOrderInstanceSetting = await SettingsService.getBySettingNameFromDb(
      "WorkOrderInstance",
    );

    if (workOrderInstanceSetting.data.value.length > 0) {
      this.WorkOrderInstance =
        workOrderInstanceSetting.data.value[0].SettingValue;
    }

    await this.setHeaderSection2DataSource();
    await this.setHeaderSection3DataSource();

    let WorkOrderTimeTabSetting = await SettingsService.getBySettingNameFromDb(
      "WorkOrderTimeTab",
    );

    if (WorkOrderTimeTabSetting.data.value.length > 0) {
      this.IsTimeFeatureEnabled =
        WorkOrderTimeTabSetting.data.value[0].SettingValue == "Y";
    }

    if (this.popupConfig.calendarDate) {
      this.model.Required = new Date(this.popupConfig.calendarDate);
    }

    if (
      this.popupConfig.workOrderCode &&
      (this.popupConfig.formMode === "review" ||
        this.popupConfig.formMode === "copy")
    ) {
      this.showLoading(true);

      if (this.popupConfig.formMode === "review") {
        await this.getWorkOrderHeaderSummary(this.popupConfig.workOrderCode);
      }

      // const response = await WorkOrderService.getByCode(
      //   this.popupConfig.workOrderCode
      // );
      // const workOrderDetail = response.data.value[0];
      const workOrderDetail = this.dataModel;
      // this.dataModel = { ...workOrderDetail };

      this.model.ReleasedQty = workOrderDetail.ActualQty;
      this.model.BomCode = workOrderDetail.BomCode;
      this.model.Branch = workOrderDetail.BranchCode;
      this.model.Code = workOrderDetail.Code;
      this.model.Comments = workOrderDetail.Comment;
      this.model.CompanyCode = workOrderDetail.CompanyCode;
      this.model.Division = workOrderDetail.DivisionCode;
      this.model.Product = workOrderDetail.ProductCode;
      this.PrimaryProduct = workOrderDetail.ProductCode;
      this.model.Quantity = workOrderDetail.ItemQty;
      this.model.MTSQuantity = workOrderDetail.MTSQuantity;
      this.model.SOQuantity = workOrderDetail.SalesOrderStockUMQuantity;
      this.model.ReleaseDepartment =
        workOrderDetail.ReleaseDepartmentCode +
        " - " +
        workOrderDetail.ReleaseDepartmentName;
      this.Status = workOrderDetail.Status;
      this.model.SchedulingMethod = workOrderDetail.SchedulingMethod;

      this.workOrderTimeDataSource.insert({
        Code: workOrderDetail.Code,
        TotalSortHour: workOrderDetail.TotalSortHour,
        TotalTegraHour: workOrderDetail.TotalTegraHour,
        TotalLabourHour: workOrderDetail.TotalLabourHour,
        TotalDownTimeHour: workOrderDetail.TotalDownTimeHour,
        DownTimeComment: workOrderDetail.DownTimeComment,
      });

      this.MTSQuantityForCopy = workOrderDetail.MTSQuantity;

      this.auditModel.createdBy = this.dataModel.CreatedBy;
      this.auditModel.dateCreated = this.dataModel.DateCreated;
      this.auditModel.changedBy = this.dataModel.ChangedBy;
      this.auditModel.dateChanged = this.dataModel.DateChanged;
      this.auditModel.dateCompleted = this.dataModel.DateCompleted;

      this.primaryProductData = await this.getProductDataForAddIn(
        workOrderDetail.ProductCode,
        workOrderDetail.BranchCode,
      );

      let retainMTSLinesOnCopySetting =
        await SettingsService.getBySettingNameFromDb("RetainMTSLinesOnCopy");

      this.RetainMTSLinesOnCopy =
        retainMTSLinesOnCopySetting.data.value[0].SettingValue;

      if (this.popupConfig.formMode === "copy") {
        this.model.Required = new Date();
        this.model.Scheduled = new Date();
        this.model.QuoteCode = 0;
        this.dataModel.FriendlyStatus = this.FriendlyStatus = "Draft";
        this.Status = "D";
      } else {
        this.model.QuoteCode = workOrderDetail.QuoteCode;
        this.model.Required = new Date(
          workOrderDetail.ShipDate.replace("Z", ""),
        );
        this.model.Scheduled = new Date(
          workOrderDetail.ScheduledDate.replace("Z", ""),
        );

        if (workOrderDetail.PlannedCompletionDate) {
          this.model.PlannedCompletionDate = new Date(
            workOrderDetail.PlannedCompletionDate.replace("Z", ""),
          );
        }

        if (
          workOrderDetail.DateCompleted &&
          !workOrderDetail.DateCompleted.startsWith("1900-01-01")
        ) {
          this.model.DateCompleted = new Date(
            workOrderDetail.DateCompleted.replace("Z", ""),
          );
        }
      }

      if (this.popupConfig.formMode !== "copy")
        this.FriendlyStatus = this.dataModel.FriendlyStatus;

      const statusConditions = {
        Cancel:
          this.dataModel.FriendlyStatus !== "Awaiting Production" &&
          this.dataModel.FriendlyStatus !== "Draft",
        Reopen:
          this.dataModel.FriendlyStatus !== "Completed" &&
          this.dataModel.FriendlyStatus !== "Cancelled",
        Complete: this.dataModel.FriendlyStatus !== "In Production",
      };

      if (
        this.FriendlyStatus === "Cancelled" ||
        this.FriendlyStatus === "Completed"
      ) {
        this.popupConfig.isEditable = false;
      } else {
        this.popupConfig.isEditable = true;
      }

      this.getToolbarMenuItems.forEach((element) => {
        if (statusConditions[element.menuText] !== undefined) {
          element.disabled = statusConditions[element.menuText];
        }

        if (
          !FeatureStorage.checkPermission(this.applicationFeatureCode, "create")
        )
          element.disabled = true;
      });

      if (this.popupConfig.formMode === "copy") {
        this.model.Quantity -= this.model.SOQuantity;
        this.model.SOQuantity = 0;
        if (this.RetainMTSLinesOnCopy == "Y") {
          this.getMTSLinesOnly(workOrderDetail.Code);
        } else {
          this.addNewLineIntoMTS();
        }
        this.addNewLineIntoProductEntry();
      } else {
        await this.getWorkOrderAddIns(workOrderDetail.Code);
        await this.getWOSalesOrderLines(workOrderDetail.Code);
      }

      if (this.popupConfig.displayForScheduleEditing) {
        this.setScheduleTabVisible = true;
        this.$nextTick(() => {
          if (this.selectedTabIndex !== this.getTabIndex("Schedule")) {
            this.selectedTabIndex = this.getTabIndex("Schedule");
          }
        });
        this.popupConfig.displayForScheduleEditing = false;
      }

      if (this.isScheduleTabVisible) {
        await this.getShiftSchedulesForWorkOrder();
      }

      this.IsAddInFeatureEnabled = await this.addInFeatureEnabled();
      if (!this.IsAddInFeatureEnabled)
        this.selectedTabIndex === this.getTabIndex("Sales Orders");

      this.IsFormLoaded = true;

      this.$nextTick(async () => {
        await this.updateHeaderAddInValues(workOrderDetail.BomCode);
        this.calculateAddInHeaderValues();
        this.showLoading(false);
      });
    } else {
      this.showLoading(true);
      DefaultCompanyBranchDivisionService.getDefault().then((result) => {
        const defaultData = result.data.value[0];
        this.model.CompanyCode = defaultData.CompanyCode;
      });

      this.IsAddInFeatureEnabled = await this.addInFeatureEnabled();
      if (!this.IsAddInFeatureEnabled)
        this.selectedTabIndex === this.getTabIndex("Sales Orders");

      if (this.popupConfig.soLines) {
        this.IsFormLoaded = true;
        if (this.selectedTabIndex != this.getTabIndex("Sales Orders"))
          this.selectedTabIndex === this.getTabIndex("Sales Orders");
        this.model.Required = null;

        if (this.popupConfig.BomCode) {
          await WorkOrderService.getBOMByCode(this.popupConfig.BomCode).then(
            (res) => {
              if (res.data.value.length > 0) {
                this.model.BomCode = res.data.value[0].Code;
                this.model.Product = res.data.value[0].ProductCode;
                this.model.Branch = res.data.value[0].BranchCode;
                this.model.Division = res.data.value[0].DivisionCode;
                this.model.Comments = res.data.value[0].Comment;
              }
            },
          );
        }
      } else this.IsFormLoaded = true;
      this.$nextTick(async () => {
        this.onShown();

        if (this.popupConfig.soLines) {
          setTimeout(async () => {
            await this.addSelectedSoLines([...this.popupConfig.soLines]);
            this.showLoading(false);
          }, 500);
        } else this.showLoading(false);
      });
    }

    this.initialRequiredDate = new Date(this.model.Required).toSaveDate();
    this.initialTotalQuantity = this.model.Quantity;

    if (this.popupConfig.formMode === "create") {
      if (this.selectedTabIndex === 0) {
        this.addNewLineIntoMTS();
      }
      this.addNewLineIntoProductEntry();
    }

    if (this.popupConfig.formMode != "review") {
      this.getWorkOrderStatus();
    }

    if (this.popupConfig.formMode === "copy") {
      if (this.selectedTabIndex === this.getTabIndex("Make to Stock")) {
        setTimeout(() => {
          this.focusOnEditableCell(0, "StockUMQuantity");
        }, 200);
      }
    }

    this.$nextTick(() => {
      if (this.popupConfig.triggerEdit) {
        setTimeout(() => {
          this.onEditPopupHandler();
        }, 100);
      }
    });
  },
  methods: {
    async getShiftSchedulesForWorkOrder() {
      await WorkOrderService.getWorkOrderShiftAllocationList(
        this.model.Code,
      ).then((response) => {
        if (IsResponseDataValid(response)) {
          this.shiftSchedules = response.data.value;
        }
      });
    },
    updateHeaderSection2Values() {
      if (this.popupConfig.formMode !== "review") {
        if (this.model.Quantity !== this.initialTotalQuantity) {
          this.isQuantityChanged = true;
        }

        this.ProductionSummary.MTSStockUMQty = this.model.MTSQuantity;
        this.ProductionSummary.MTSProductionMQty =
          this.model.MTSQuantity / this.AddInSalesUMConversion;

        this.ProductionSummary.AddInStockUMQty =
          this.model.AddInStockUMQuantity;
        this.ProductionSummary.AddInProductionUMQty =
          this.model.AddInSalesUMQuantity;

        this.ProductionSummary.SalesOrderStockUMQty = this.model.SOQuantity;
        this.ProductionSummary.SalesOrderProductionUMQty =
          this.model.SOQuantity / this.AddInSalesUMConversion;

        this.ProductionSummary.WorkOrderStockUMQty = this.model.Quantity;
        this.ProductionSummary.WorkOrderProductionUMQty =
          this.model.Quantity / this.AddInSalesUMConversion;

        this.resetAndRefreshHeaderTotals(true);
      }
    },
    async setHeaderSection2DataSource() {
      this.headerSection2DataSource.clear();
      this.headerSection2DataSource.insert({
        Title: "MTS Qty",
        StockUMQty: this.ProductionSummary.MTSStockUMQty,
        ProductionUMQty: this.ProductionSummary.MTSProductionMQty,
      });

      this.headerSection2DataSource.insert({
        Title: "Add In Qty",
        StockUMQty: this.ProductionSummary.AddInStockUMQty,
        ProductionUMQty: this.ProductionSummary.AddInProductionUMQty,
      });

      this.headerSection2DataSource.insert({
        Title: "SO Qty",
        StockUMQty: this.ProductionSummary.SalesOrderStockUMQty,
        ProductionUMQty: this.ProductionSummary.SalesOrderProductionUMQty,
      });

      this.headerSection2DataSource.insert({
        Title: "WO Qty",
        StockUMQty: this.ProductionSummary.WorkOrderStockUMQty,
        ProductionUMQty: this.ProductionSummary.WorkOrderProductionUMQty,
      });

      this.headerSection2DataSource.insert({
        Title: "Released Qty",
        StockUMQty: this.ProductionSummary.ReleasedStockUMQty,
        ProductionUMQty: this.ProductionSummary.ReleasedProductionUMQty,
      });

      this.headerSection2DataSource.insert({
        Title: "Variance",
        StockUMQty: 0,
        ProductionUMQty: 0,
        VarianceStockUMQty: this.ProductionSummary.VarianceStockUMQty,
        VarianceProductionUMQty: this.ProductionSummary.VarianceProductionUMQty,
      });

      if (this.WorkOrderInstance === "Almondco") {
        this.headerSection2DataSource.insert({
          Title: "Send to Production",
          StockUMQty: this.ProductionSummary.SendToProductionStockUMQty,
          ProductionUMQty:
            this.ProductionSummary.SendToProductionProductionUMQty,
        });
      } else {
        this.headerSection2DataSource.insert({
          Title: "",
          StockUMQty: 0,
          ProductionUMQty: 0,
          VarianceStockUMPercent: this.ProductionSummary.VarianceStockUMPercent,
          VarianceProductionUMPercent:
            this.ProductionSummary.VarianceProductionUMPercent,
        });
      }
    },
    async setHeaderSection3DataSource() {
      this.headerSection3DataSource.clear();

      if (this.WorkOrderInstance === "Almondco") {
        this.headerSection3DataSource.insert({
          Title: "Material Issued",
          Weight: this.MaterialSummary.MaterialIssued,
          Value: null,
        });
        this.headerSection3DataSource.insert({
          Title: "Material Added In",
          Weight: this.MaterialSummary.MaterialAddedIn,
          Value: null,
        });

        this.headerSection3DataSource.insert({
          Title: "Material Returned",
          Weight: this.MaterialSummary.MaterialReturned,
          Value: null,
        });

        this.headerSection3DataSource.insert({
          Title: "Bi-Product",
          Weight: this.MaterialSummary.BiProduct,
          Value: this.MaterialSummary.BiProductPercent,
        });

        this.headerSection3DataSource.insert({
          Title: "Rubbish",
          Weight: this.MaterialSummary.Rubbish,
          Value: null,
        });

        this.headerSection3DataSource.insert({
          Title: "Brown Reclaim",
          Weight: this.MaterialSummary.BrownReclaimStockUMQty,
          Value: this.MaterialSummary.BrownReclaimPercent,
        });

        this.headerSection3DataSource.insert({
          Title: "White Reclaim",
          Weight: this.MaterialSummary.WhiteReclaimStockUMQty,
          Value: this.MaterialSummary.WhiteReclaimPercent,
        });

        this.headerSection3DataSource.insert({
          Title: "Loss / Gain",
          Weight: this.MaterialSummary.LossGainStockUMQty,
          Value: this.MaterialSummary.LossGainPercent,
        });
      } else {
        this.setHeaderSection3Part2DataSource();
        this.headerSection3DataSource.insert({
          Title: "Materials",
          PlannedCost: this.CostSummary.MaterialsPlannedCost,
          ActualCost: this.CostSummary.MaterialsActualCost,
          Variance: this.CostSummary.MaterialsVarianceCost,
          VariancePercentage: this.CostSummary.MaterialsVariancePercent,
        });

        this.headerSection3DataSource.insert({
          Title: "Labour",
          PlannedCost: this.CostSummary.LabourPlannedCost,
          ActualCost: this.CostSummary.LabourActualCost,
          Variance: this.CostSummary.LabourVarianceCost,
          VariancePercentage: this.CostSummary.LabourVariancePercent,
        });

        this.headerSection3DataSource.insert({
          Title: "Full Manufactured",
          PlannedCost: this.CostSummary.FullManufacturedPlannedCost,
          ActualCost: this.CostSummary.FullManufacturedActualCost,
          Variance: this.CostSummary.FullManufacturedVarianceCost,
          VariancePercentage: this.CostSummary.FullManufacturedVariancePercent,
        });
      }
    },
    setHeaderSection3Part2DataSource() {
      this.headerSection3Part2DataSource.clear();
      this.headerSection3Part2DataSource.insert({
        Title: "Stock UM",
        PlannedCost: this.CostSummary.StockUMPlannedCost,
        ActualCost: this.CostSummary.StockUMActualCost,
        Variance: this.CostSummary.StockUMVarianceCost,
        VariancePercentage: this.CostSummary.StockUMVariancePercent,
      });
      this.headerSection3Part2DataSource.insert({
        Title: "Production UM",
        PlannedCost: this.CostSummary.ProductionUMPlannedCost,
        ActualCost: this.CostSummary.ProductionUMActualCost,
        Variance: this.CostSummary.ProductionUMVarianceCost,
        VariancePercentage: this.CostSummary.ProductionUMVariancePercent,
      });
    },
    resetSummaries() {
      // Preserve reactivity by updating properties, not replacing objects
      Object.assign(this.ProductionSummary, defaultProductionSummary());
      Object.assign(this.MaterialSummary, defaultMaterialSummary());
      Object.assign(this.CostSummary, defaultCostSummary());
    },
    onRefreshDataList() {
      if (
        this.IsFormLoaded &&
        this.selectedTabIndex === this.getTabIndex("Releases")
      ) {
        let dataGrid = this.$refs["wo-release-grid"].instance;
        if (dataGrid) {
          dataGrid.refresh(true);
        }
      }

      if (
        this.IsFormLoaded &&
        this.selectedTabIndex === this.getTabIndex("Issues")
      ) {
        let dataGrid =
          this.$refs["issues-tab-grid-component"].$refs["issues-tab-grid"]
            .instance;
        if (dataGrid) {
          dataGrid.refresh(true);
        }
      }
      this.getWorkOrderHeaderSummary(this.popupConfig.workOrderCode);

      if (this.$refs["materials-tab-grid-component"]) {
        this.$refs["materials-tab-grid-component"].getWorkOrderMaterialList(
          this.popupConfig.workOrderCode,
        );
      }
    },
    async onRefreshWorkOrderHeader() {
      this.saveCallBack(false);
      try {
        const response = await WorkOrderService.getByCode(this.model.Code, [
          "Code",
          "FriendlyStatus",
          "Status",
        ]);
        if (response.data.value.length > 0) {
          const workOrderDetail = response.data.value[0];
          this.dataModel.FriendlyStatus = workOrderDetail.FriendlyStatus;
          this.FriendlyStatus = workOrderDetail.FriendlyStatus;
          this.Status = workOrderDetail.Status;

          if (
            this.FriendlyStatus === "Cancelled" ||
            this.FriendlyStatus === "Completed"
          ) {
            this.popupConfig.isEditable = false;
          }

          setTimeout(async () => {
            if (this.StatusComponent) {
              await this.getWorkOrderStatus();
              this.$nextTick(() => {
                this.StatusInitialized(this.StatusComponent);
              });
            }
          }, 100);
        }
      } catch (error) {
        this.displayServerError(error, "Work Order Header Refresh Error");
      }
    },
    async getWorkOrderStatus() {
      const [statusRes, transitionRes] = await Promise.all([
        WorkOrderService.getWorkOrderStatus(),
        WorkOrderService.getWorkOrderStatusTransition(this.Status),
      ]);

      const statusArray = statusRes.data.value;
      const transitionArray = transitionRes.data.value;

      const validTransitions = transitionArray.map((t) => ({
        ToStatusCode: t.ToStatusCode,
        Sequence: t.Sequence,
      }));

      var currentStatus = statusArray.find((s) => s.Code === this.Status);

      validTransitions.push({
        ToStatusCode: currentStatus.Code,
        Sequence: currentStatus.Sequence,
      }); // ensure current status is included

      validTransitions.sort((a, b) => a.Sequence - b.Sequence);

      const toStatusCodesSet = new Set(
        validTransitions.map((t) => t.ToStatusCode),
      );

      this.StatusDataSource = Array.from(toStatusCodesSet).map((code) => {
        const status = statusArray.find((s) => s.Code === code);
        return {
          Code: status.Code,
          FriendlyStatus: status.FriendlyStatus,
          visible:
            (this.popupConfig.formMode === "create" ||
              this.popupConfig.formMode === "copy") &&
            status.FriendlyStatus === "Cancelled"
              ? false
              : true,
        };
      });
    },
    releasePopupHide() {
      this.HotKeyWatcherEnabled = true;
      this.releasePopupInfo.isPopupShow = false;
      this.releaseModelInfo.isPopupShow = false;
    },
    materialPopupHide() {
      this.HotKeyWatcherEnabled = true;
      this.issueModelInfo.isPopupShow = false;
    },
    onGridInitialized(e) {
      if (
        this.popupConfig.formMode !== "review" &&
        this.selectedTabIndex === this.getTabIndex("Add In")
      )
        setTimeout(() => {
          this.$nextTick(() => {
            this.reSizeGrid(e.component);
          });
        }, 100);
    },
    reSizeGrid(component) {
      component.beginUpdate();
      component.updateDimensions();
      component.endUpdate();

      // this.$nextTick(() => {
      //   component.refresh(true);
      // });
    },
    addInRowUpdated() {
      if (this.selectedTabIndex === this.getTabIndex("Add In")) {
        this.calculateAddInHeaderValues();
      }
    },
    reFocusOnQty(currentRowData, dataField) {
      let dataGrid = this.$refs["wo-add-in-grid"].instance;
      let rowIndex = dataGrid.getRowIndexByKey(currentRowData.ID);
      if (rowIndex != -1) {
        setTimeout(() => {
          this.focusOnEditableCell(rowIndex, dataField);
        }, 10);
      }
    },
    onEditorPreparing(e) {
      if (e.editorOptions && e.editorOptions.onKeyDown) {
        let func = e.editorOptions.onKeyDown;
        if (
          this.popupConfig.formMode != "review" &&
          e.parentType != "searchPanel"
        )
          e.editorOptions.onKeyDown = (event) => {
            func(event, {
              column: {
                dataField: e.dataField,
              },
              data: e.row.data,
              rowIndex: e.row.rowIndex,
            });
          };
      }

      if (e.editorOptions && e.editorOptions.onItemClick) {
        let func = e.editorOptions.onItemClick;
        if (
          this.popupConfig.formMode != "review" &&
          e.parentType != "searchPanel"
        )
          e.editorOptions.onItemClick = (event) => {
            func(event, {
              column: {
                dataField: e.dataField,
              },
              data: e.row.data,
              rowIndex: e.row.rowIndex,
            });
          };
      }

      if (e.editorOptions && e.editorOptions.onFocusIn) {
        let func = e.editorOptions.onFocusIn;
        if (
          this.popupConfig.formMode != "review" &&
          e.parentType != "searchPanel"
        )
          e.editorOptions.onFocusIn = (event) => {
            func(event, {
              column: {
                dataField: e.dataField,
              },
              data: e.row.data,
              rowIndex: e.row.rowIndex,
            });
          };
      }

      if (e.editorOptions && e.editorOptions.onFocusOut) {
        let func = e.editorOptions.onFocusOut;
        if (
          this.popupConfig.formMode != "review" &&
          e.parentType != "searchPanel"
        )
          e.editorOptions.onFocusOut = (event) => {
            func(event, {
              column: {
                dataField: e.dataField,
              },
              data: e.row.data,
              rowIndex: e.row.rowIndex,
            });
          };
      }

      if (e.editorOptions && e.editorOptions.onInput) {
        let func = e.editorOptions.onInput;
        if (
          this.popupConfig.formMode != "review" &&
          e.parentType != "searchPanel"
        )
          e.editorOptions.onInput = (event) => {
            func(event, {
              column: {
                dataField: e.dataField,
              },
              data: e.row.data,
              rowIndex: e.row.rowIndex,
            });
          };
      }

      if (e.dataField && e.dataField == "ItemCode") {
        e.editorName = "dxSelectBox";
      }

      if (
        e.dataField &&
        (e.dataField == "Comment" || e.dataField == "DownTimeComment")
      ) {
        e.editorName = "dxTextArea";
      }

      if (this.selectedTabIndex === this.getTabIndex("Add In")) {
        if (e.dataField && e.dataField == "ItemCode") {
          e.editorName = "dxSelectBox";
        }
      }

      if (this.selectedTabIndex === this.getTabIndex("Sales Orders"))
        if (e.dataField && e.dataField == "Note") {
          e.editorName = "dxTextArea";
        }
    },

    onEnterItemCode(e, lineData) {
      if (e.event.key == "Enter" && lineData) {
        setTimeout(() => {
          if (lineData && !lineData.data.ItemCode) {
            // eslint-disable-next-line no-console
            console.log("Clicked on a field other than the Item Code Field");
          } else this.focusOnEditableCell(lineData.rowIndex, "RequiredByDate");
        }, 100);
      }

      if (e.event.keyCode == 9 && e.event.shiftKey) {
        e.event.preventDefault();
      }
    },
    focusOnEditableCell(rowIndex, col) {
      var columnName = col ? col : "ItemCode";
      if (!this.getDataGridInstance) return;
      var dataGrid = this.getDataGridInstance;

      var cellElement = dataGrid.getCellElement(rowIndex, columnName);
      dataGrid.focus(cellElement);
      setTimeout(() => {
        dataGrid.editCell(rowIndex, columnName);
      }, 10);
    },
    async productCodeFocusIn(e) {
      e.event.target.select();
    },

    addNewLineIntoMTS(data, type) {
      let maxID = 10000;

      let dataObj = Object.assign({ ...productEntryBase });
      if (type === "copy-line") {
        if (data) {
          dataObj = Object.assign(
            { IsCopyLine: true, IsNewLine: true },
            data.row.data,
          );

          maxID = Math.max(...this.mtsDataSource._array.map((e) => e.ID));
          dataObj.ID = ++maxID;
        }

        this.changes = [
          {
            type: "insert",
            data: { ...dataObj },
            insertAfterKey: data.row.key,
          },
        ];

        if (!this.getDataGridInstance) return;
        var dataGrid = this.getDataGridInstance;

        setTimeout(() => {
          dataGrid.saveEditData();
          dataGrid.refresh(true);
        }, 100);
      } else {
        dataObj.ID = maxID;

        if (this.mtsDataSource._array.length != 0) {
          maxID = Math.max(...this.mtsDataSource._array.map((e) => e.ID));
          dataObj.ID = ++maxID;
        }

        if (data) {
          this.mtsDataSource.clear();
          dataObj = Object.assign({ IsNewLine: true }, dataObj, data);

          if (!this.getDataGridInstance) return;
          dataGrid = this.getDataGridInstance;

          setTimeout(() => {
            dataGrid.saveEditData();
            dataGrid.refresh(true).then(() => {
              this.$nextTick(() => {
                this.selectedTabIndex = this.getTabIndex("Make to Stock");
                setTimeout(() => {
                  this.focusOnEditableCell(0, "StockUMQuantity");
                }, 200);
              });
            });
          }, 100);
        }

        this.mtsDataSource.insert(dataObj);
      }
    },

    onSaved(e) {
      if (e.changes && e.changes.length > 0) {
        const change = e.changes[0];
        if (change.insertAfterKey !== undefined) {
          const element = change.data;
          let column = undefined;
          let index = -1;
          if (this.selectedTabIndex === 0) {
            index = this.mtsDataSource._array.findIndex(
              (x) => x.ID === change.insertAfterKey,
            );
            this.mtsDataSource._array.splice(
              this.mtsDataSource._array.length - 1,
              1,
            );
            this.mtsDataSource._array.splice(index + 1, 0, element);
          }

          if (index !== -1 && element.Reverse !== true)
            setTimeout(() => {
              this.focusOnEditableCell(index + 1, column);
            }, 100);
        }
      }
    },
    onRowRemoved(e) {
      if (this.mtsDataSource._array.length === 0) {
        this.addNewLineIntoMTS();
        e.component.refresh();
      }
    },

    addNewLineIntoProductEntry(data, type) {
      let maxID = 10000;

      let dataObj = Object.assign({ ...productEntryBase });
      if (data) {
        dataObj = Object.assign({ IsCopyLine: false, IsNewLine: true }, data);
      }
      dataObj.ID = maxID;

      if (this.addInDataSource._array.length != 0) {
        maxID = Math.max(...this.addInDataSource._array.map((e) => e.ID));
        dataObj.ID = ++maxID;
      }

      this.addInDataSource.insert(dataObj);

      if (type) {
        let dataGrid = this.$refs["wo-add-in-grid"].instance;
        dataGrid.refresh().then(() => {
          let rowIndex = dataGrid.getRowIndexByKey(dataObj.ID);

          if (rowIndex != -1) {
            this.focusOnEditableCell(rowIndex, "ItemCode");
          }
        });
      }
    },
    async addInFeatureEnabled() {
      return FeatureStorage.checkPermission("WorkOrderAddIn", "review");
    },
    async handleTabClick(e) {
      this.selectedTabIndex = e.itemIndex;

      // this.$nextTick(async () => {
      //   if (this.getDataGridInstance) {
      //     this.getDataGridInstance.repaint();
      //     setTimeout(async () => {
      //       if (e.itemData.text === "Sales Orders") {
      //         // await this.getDataGridInstance.clearSelection();
      //         // await this.getDataGridInstance.deselectAll();
      //         this.setSoLineSelection();
      //       }
      //     }, 1);
      //   }
      // });

      // if (e.itemData.text === "Sales Orders") {
      //   this.setSoLineSelection();
      // }
    },
    onRowReorder(e) {
      let itemData = e.itemData;

      const toIndex = e.toIndex;
      const fromIndex = e.fromIndex;
      if (this.selectedTabIndex === 0) {
        let newTasks = [...this.mtsDataSource._array];

        // Find and extract the empty ItemCode element (if exists)
        const emptyItemIndex = newTasks.findIndex((item) => !item.ItemCode);
        let emptyItem = null;
        if (emptyItemIndex !== -1) {
          emptyItem = newTasks.splice(emptyItemIndex, 1)[0]; // Remove empty item
        }

        // Perform the reordering
        newTasks.splice(fromIndex, 1);
        newTasks.splice(toIndex, 0, itemData);

        // Reattach the empty item at the end if it was removed
        if (emptyItem) {
          newTasks = newTasks.filter((item) => item.ItemCode); // Ensure no duplicate empty item
          newTasks.push(emptyItem);
        }

        this.mtsDataSource._array = newTasks;
      } else if (this.selectedTabIndex === 2) {
        const newTasks = [...this.soLinesDataSource._array];

        newTasks.splice(fromIndex, 1);
        newTasks.splice(toIndex, 0, itemData);

        this.soLinesDataSource._array = newTasks;
      }

      this.$nextTick(() => {
        if (!this.getDataGridInstance) return;
        let instance = this.getDataGridInstance;
        if (instance) instance.refresh();
      });
    },
    async getWorkOrderAddIns(workOrderCode) {
      await WorkOrderService.getWorkOrderAddIns(workOrderCode).then((res) => {
        if (res !== null) {
          res.data.value.forEach((element, index) => {
            element.ItemCode = element.ProductCode;
            element.ItemDescription = element.ProductDescription;
            element.ID = index + 1;
            this.addInDataSource.insert(element);
          });
        }
      });
    },
    async getMTSLinesOnly(code) {
      let res = await WorkOrderService.getWOSOLines(code);

      if (res.data.value.length === 0) {
        this.addMTSLineOnCopy();
      } else {
        res.data.value.forEach((element, index) => {
          if (element.SalesOrderCode === 0) {
            element.ID = index + 1;
            element.SalesUMQuantity = element.SalesOrderSalesUMQuantity;
            element.StockUMQuantity = element.SalesOrderStockUMQuantity;
            element.SalesOrderShipDate = new Date(
              element.SalesOrderShipDate.replace("Z", ""),
            );
            element.IsSelected = true;
            element.ItemCode = element.ProductCode;
            element.ItemDescription = element.ProductDescription1;
            this.mtsDataSource.insert(element);
          }
        });
      }

      if (!this.getDataGridInstance) return;
      let dataGrid = this.getDataGridInstance;

      setTimeout(() => {
        dataGrid.saveEditData();
        dataGrid.refresh(true);
      }, 100);
      this.$nextTick(() => {
        this.selectedTabIndex = this.getTabIndex("Make to Stock");
        setTimeout(() => {
          this.focusOnEditableCell(0, "StockUMQuantity");
        }, 200);
      });
    },
    async getWOSalesOrderLines(code) {
      await WorkOrderService.getWOSOLines(code).then((res) => {
        res.data.value.forEach((element, index) => {
          element.SalesUMQuantity = element.SalesOrderSalesUMQuantity;
          element.StockUMQuantity = element.SalesOrderStockUMQuantity;
          element.SalesOrderShipDate = new Date(
            element.SalesOrderShipDate.replace("Z", ""),
          );
          element.IsSelected = true;
          if (element.SalesOrderCode === 0) {
            element.ID = index + 1;
            element.ItemCode = element.ProductCode;
            element.ItemDescription = element.ProductDescription1;
            this.mtsDataSource.insert(element);
          } else {
            this.soLinesDataSource.insert(element);
          }
        });
      });
    },
    setSoLineModel() {
      this.selectedTabIndex === this.getTabIndex("Sales Orders");
      this.soPopupConfig.ProductInfo = this.selectedProdData;
      this.soPopupConfig.visible = true;
      this.setSoLineSelection();
    },
    /**
     * Handle Audit Popup
     */
    onAuditPopupHandler() {
      this.popupAuditVisible = !this.popupAuditVisible;
    },

    /**
     * on popup model shown
     */
    onShown() {
      // if (this.dataModel) {
      //   this.FriendlyStatus = this.dataModel.FriendlyStatus;
      // }
      this.$store.dispatch("hotKey/setHotKeyPopupMode", true);
      setTimeout(() => this.setFocusOnField("BomCode"), 700);
    },

    /**
     * on pop up model hide
     */
    onPopupHide() {
      this.dataModel.Code = null;
      this.dataModel.WorkOrderCode = null;
      this.dataModel.Branch = null;

      // Reset tracking flags
      this.initialRequiredDate = null;
      this.isRequiredDateChanged = false;
      this.initialTotalQuantity = 0;
      this.isQuantityChanged = false;
      this.isProcessTabChanged = false;

      this.onHide();
      this.$store.dispatch("hotKey/setHotKeyPopupMode", false);
    },

    onInitialized(e) {
      if (this.popupConfig.formMode !== "review")
        e.component.registerKeyHandler("escape", (arg) => {
          arg.stopPropagation();
        });
    },

    /**
     * Preview PDF Report
     */
    async onPreviewPDF(pdfData) {
      if (pdfData) {
        this.showLoading(true);
        var response;
        await TransactionReportService.getByFeatureCode(
          pdfData.ScreenLayoutApplicationFeatureCode,
        )
          .then((res) => {
            response = res;
          })
          .catch((err) => {
            if (err) this.showLoading(false);
            this.$alert("Report repx not found", "Error");
            return;
          });

        var report = undefined;
        if (response && response.data) {
          report = response.data;
          report.Parameters = JSON.parse(response.data.Parameters);

          let link = `/api/GetReportPdf?reportLocation=${report.Location}`;

          report.Parameters.forEach((element) => {
            let globalField = { ...getGlobalField(element.screenField) };

            if (globalField) {
              link += `&${globalField.dataField}=${this.dataModel.Code}`;
            }
          });

          await ApiService.get(link)
            .then((res) => {
              const blob = b64toBlob(res.data, "application/pdf");
              const blobUrl = URL.createObjectURL(blob);
              this.showLoading(false);

              Object.assign(document.createElement("a"), {
                target: "_blank",
                href: blobUrl,
              }).click();
            })
            .catch((error) => {
              this.$logger.debug("ExportToPdf Error ", error);
              this.showLoading(false);
            });
        }
      }
    },

    /**
     * On Value Changed
     * @param e
     */
    async onBomValueChanged(e) {
      let confirmBOMChange = false;
      if (!e.event) return;
      else {
        this.refreshOnUpdate = false;
        if (this.popupConfig.formMode === "edit") {
          confirmBOMChange = await this.$confirm(
            `Changing the BOM will reset this Work Order’s materials, processes, and time planning to match the new selection. </br>
            Make to Stock, Sales Order links, Work Order Quantity, and Add-In Lines will remain unchanged. </br>
            Do you wish to continue with the BOM change?`,
            "Confirm Change",
            {
              confirmButtonText: "Yes",
              cancelButtonText: "No",
              type: "warning",
            },
          );

          if (!confirmBOMChange) {
            this.model.BomCode = e.previousValue;
            e.component.beginUpdate();
            e.component.option("value", e.previousValue);
            e.component.endUpdate();
            return;
          }
        }

        if (
          e.value &&
          e.previousValue &&
          this.popupConfig.formMode === "create"
        ) {
          if (
            e.value != e.previousValue &&
            (this.mtsDataSource._array.length > 1 ||
              this.addInDataSource._array.length > 1 ||
              this.soLinesDataSource._array.length > 0)
          ) {
            const confirm = await this.$confirm(
              `Changing the BOM that is being used to create this Work Order will reset the data on all associated tabs. Are you sure you would like to proceed?`,
              "Confirm Change",
              {
                confirmButtonText: "Yes",
                cancelButtonText: "No",
                type: "warning",
              },
            );

            if (!confirm) {
              e.component.beginUpdate();
              e.component.option("value", e.previousValue);
              e.component.endUpdate();
              return;
            } else {
              this.model.Quantity = 0;
              this.model.SOQuantity = 0;
              this.mtsDataSource.clear();
              this.addInDataSource.clear();
              this.soLinesDataSource.clear();

              // this.addNewLineIntoMTS();
              this.addNewLineIntoProductEntry();
              this.calculateAddInHeaderValues();

              if (this.$refs["wo-so-line-grid"]) {
                let grid = this.$refs["wo-so-line-grid"].instance;
                grid.refresh(true);
              }

              if (this.getDataGridInstance) {
                this.getDataGridInstance.refresh(true);
              }
            }
          }
        }

        if (
          this.model.SOQuantity === 0 &&
          this.popupConfig.formMode === "create"
        ) {
          this.model.Quantity = 0;
        }
      }

      let instance = e.component;

      if (e.value) {
        let selectedItem = instance.getDataSource()
          ? instance
              .getDataSource()
              .items()
              .find((x) => x.Code === e.value)
          : null;

        if (!selectedItem) {
          await WorkOrderService.getBOMByCode(e.value).then((res) => {
            selectedItem = res.data.value[0];
          });
        }

        if (!selectedItem) return;
        if (this.popupConfig.formMode === "create") {
          this.model.SchedulingMethod = selectedItem.SchedulingMethod;
          await this.updateHeaderAddInValues(e.value);
        }

        if (this.model.Product !== selectedItem.ProductCode) {
          this.updateFormValues("Product", selectedItem.ProductCode);
        }

        if (
          this.model.SOQuantity != 0 &&
          this.popupConfig.formMode === "create"
        ) {
          if (selectedItem.BatchSize > this.model.SOQuantity) {
            this.model.MTSQuantity =
              this.model.Quantity - this.model.SOQuantity;
          } else this.Quantity = this.model.MTSQuantity + this.model.SOQuantity;
        }
        this.updateFormValues("Branch", selectedItem.BranchCode);
        this.updateFormValues("Division", selectedItem.DivisionCode);
        this.updateFormValues("Comments", selectedItem.Comment);

        this.selectedBOMData = selectedItem;

        this.primaryProductData = await this.getProductDataForAddIn(
          selectedItem.ProductCode,
          selectedItem.BranchCode,
        );

        //
        if (this.popupConfig.formMode === "create") {
          await this.addMTSLineFromProduct(selectedItem);
        }
      } else {
        this.model.Product = null;
        this.model.Comments = null;
        this.model.Branch = null;
        this.model.Division = null;
        this.primaryProductData = undefined;

        if (this.model.SOQuantity === 0) {
          this.model.Quantity = 0;
          this.model.MTSQuantity = 0;
        }
      }

      if (this.popupConfig.formMode === "edit" && confirmBOMChange) {
        this.onSavePopupHandler(false, true);
      }
    },

    async addMTSLineFromProduct(selectedItem, MTSQuantityForCopy = 0) {
      let item;
      let response = await ProductService.getByCode(selectedItem.ProductCode);

      if (response.data.value.length > 0) {
        item = response.data.value[0];
      }

      if (item) {
        var newData = {};
        newData.ItemCode = item.Code;

        if (item) {
          newData.ItemDescription = item.Description1;
          newData.SalesUM = item.SalesUM;
          newData.StockUM = item.StockUM || item.UnitOfMeasureCode;
          // newData.AddInStockUMQty = allowedTotal > item.Available ? item.Available : allowedTotal;
          newData.OnHand = item.OnHand;
          newData.OnHandSalesUMQty = item.OnHandSalesUMQty;
          newData.SalesUMConversion = item.SalesUMConversion;
          newData.RecordId = "00000000-0000-0000-0000-000000000000";
          newData.Available = item.Available;
          newData.AvailableSalesUMQty = item.AvailableSalesUMQty;
          newData.OriginalAvailable = item.Available;
          newData.OriginalAvailableSalesUMQty = item.AvailableSalesUMQty;
          newData.QtyValidation = true;
          newData.AddInSalesUMQty = 0;
          newData.AddInSalesUMQty = 0;
          newData.StockUMQuantity = MTSQuantityForCopy;
        }

        this.addNewLineIntoMTS(newData);
        this.addNewLineIntoMTS();
      }
    },

    async getProductDataForAddIn(productCode, branchCode) {
      let productData = await WorkOrderService.getProductDataForAddInDataSource(
        productCode,
        branchCode,
      );

      if (!productData.data || productData.data.value.length === 0) return null;

      return productData.data.value[0];
    },
    async updateHeaderAddInValues(bomCode) {
      let result = await WorkOrderService.getBomUnitOfMeasure(bomCode);

      if (result.data.value.length > 0) {
        let bomUOM = result.data.value[0];

        if (bomUOM) {
          this.AddInSalesUM = bomUOM.UnitOfMeasureCode;
          this.AddInSalesUMConversion = bomUOM.Conversion;

          if (this.popupConfig.formMode !== "review") {
            this.ProductionSummary.ProductionUM = bomUOM.UnitOfMeasureCode;
            this.resetAndRefreshHeaderTotals(true);
          }

          if (
            this.$refs["gc-header-form"] &&
            this.$refs["gc-header-form"].$refs["gc-form-comp"]
          ) {
            const form =
              this.$refs["gc-header-form"].$refs["gc-form-comp"].instance;
            form.beginUpdate();
            form.itemOption("AddInStockUMQuantity", "label", {
              text: `Add In (${this.AddInStockUM})`,
            });

            form.itemOption("AddInSalesUMQuantity", "label", {
              text: `Add In (${this.AddInSalesUM})`,
            });
            form.endUpdate();
          }
        }
      }
    },
    onEditPopupHandler() {
      this.getWorkOrderStatus();
      this.popupConfig.formMode = "edit";
      this.popupConfig.hideOnOutsideClick = false;
      this.popupConfig.formKey++;

      if (this.dataModel.FriendlyStatus === "In Production")
        setTimeout(() => this.setFocusOnField("Comments"), 50);
      else setTimeout(() => this.setFocusOnField("Required"), 50);

      this.addNewLineIntoMTS();
      this.addNewLineIntoProductEntry();

      setTimeout(() => {
        this.$nextTick(() => {
          if (this.selectedTabIndex === this.getTabIndex("Add In")) {
            if (!this.$refs["wo-add-in-grid"]) return;
            let grid = this.$refs["wo-add-in-grid"].instance;
            grid.refresh();
          } else {
            if (!this.$refs["wo-so-line-grid"]) return;
            let grid = this.$refs["wo-so-line-grid"].instance;

            let IDs = [];
            this.soLinesDataSource._array.forEach((element) => {
              IDs.push({
                SalesOrderCode: element.SalesOrderCode,
                SalesOrderLine: element.SalesOrderLine,
              });
            });

            grid.selectRows(IDs, true);
          }

          if (this.getDataGridInstance) {
            this.getDataGridInstance.refresh();
          }

          if (this.setScheduleTabVisible) {
            if (this.selectedTabIndex === this.getTabIndex("Schedule")) {
              const instance =
                this.$refs["scheduling-tab-grid-component"].$refs[
                  "scheduling-tab-grid"
                ].instance;

              if (instance) {
                const dataSource = instance.option("dataSource");
                if (dataSource && dataSource.length > 0) {
                  this.$refs[
                    "scheduling-tab-grid-component"
                  ].focusOnEditableCell(0, "ProcessCode");
                }
              }
            }
          }
        });
      }, 10);
    },

    setSoLineSelection() {
      this.$nextTick(() => {
        if (!this.$refs["wo-so-line-grid"]) return;
        let grid = this.$refs["wo-so-line-grid"].instance;

        if (grid) {
          let IDs = [];
          this.soLinesDataSource._array.forEach((element) => {
            if (element.IsSelected) {
              IDs.push({
                SalesOrderCode: element.SalesOrderCode,
                SalesOrderLine: element.SalesOrderLine,
              });
            }
          });

          if (IDs.length > 0) {
            grid.refresh(true).then(() => {
              setTimeout(() => {
                grid.selectRows(IDs, true);
              }, 100);
            });
          }
        }
      });
    },
    onDraftSave() {
      this.saveAsDraft = true;
      this.onSavePopupHandler();
    },

    validateProcessDurations(arr) {
      const map = {};

      arr.forEach(({ ProcessCode, DurationMins, TotalProcessMinutes }) => {
        if (!ProcessCode) return;

        if (!map[ProcessCode]) {
          map[ProcessCode] = {
            totalDuration: 0,
            expectedTotal: TotalProcessMinutes,
            isValid: true,
          };
        }

        map[ProcessCode].totalDuration += DurationMins || 0;

        // Optional: detect mismatch in expected totals within same process
        if (
          TotalProcessMinutes != null &&
          map[ProcessCode].expectedTotal !== TotalProcessMinutes
        ) {
          map[ProcessCode].isValid = false;
        }
      });

      // Final equality check
      Object.values(map).forEach((p) => {
        p.isValid = p.isValid && p.totalDuration === p.expectedTotal;
      });

      return map;
    },

    validateProcessDurationsArray(arr) {
      const result = this.validateProcessDurations(arr);

      return Object.entries(result).map(
        ([ProcessCode, { totalDuration, expectedTotal, isValid }]) => ({
          ProcessCode,
          totalDuration,
          expectedTotal,
          isValid,
        }),
      );
    },

    /**
     * On Save Popup Handler
     */
    async onSavePopupHandler(e, BOMUpdate = false) {
      await this.focusOutFromEditableCells();
      await this.$nextTick();

      if (this.Status === "X") {
        this.onCancelWorkOrderHandler();
      } else {
        if (this.model.BomCode === "" || this.model.BomCode === null) {
          await this.$alert("Bom Code Required", "Validation Error");
          this.setFocusOnField("BomCode");
        } else if (this.model.Product === "" || this.model.Product === null) {
          await this.$alert("Product Code Required", "Validation Error");
          this.setFocusOnField("BomCode");
        } else if (this.model.Required === null) {
          await this.$alert("Required Date Required", "Validation Error");
          this.setFocusOnField("Required");
        } else if (this.model.Branch === "" || this.model.Branch === null) {
          await this.$alert("Branch Required", "Validation Error");
          this.setFocusOnField("Branch");
        } else if (this.model.Division === "" || this.model.Division === null) {
          await this.$alert("Division Required", "Validation Error");
          this.setFocusOnField("Division");
        } else if (this.model.Quantity === 0) {
          if (
            this.popupConfig.formMode === "edit" &&
            (this.dataModel.FriendlyStatus === "Awaiting Production" ||
              this.dataModel.FriendlyStatus === "Draft")
          ) {
            let confirmCancel = await this.$confirm(
              "You are attempting to edit the Work Order Quantity to 0.0000. Would you like to cancel this Work Order?",
              "Cancel Work Order",
            );

            if (confirmCancel) {
              this.onCancelWorkOrder();
            } else return;
          } else if (
            this.popupConfig.formMode === "edit" &&
            this.dataModel.FriendlyStatus === "In Production"
          ) {
            let confirmComplete = await this.$confirm(
              "You are attempting to edit the Work Order Quantity to 0.0000. Would you like to complete this Work Order?",
              "Complete Work Order",
            );

            if (confirmComplete) {
              this.onCompleteWorkOrder();
            } else return;
          } else {
            await this.$alert(
              "You have attempted to set the Work Order Quantity to 0.0000. Please enter a Work Order Quantity that is greater than 0.0000 before attempting to save.",
              "Validation Error",
            );
            this.setFocusOnField("Division");
          }
        } else {
          const payload = {
            Code: this.model.Code,
            QuoteCode: this.model.QuoteCode,
            DateIn: new Date(this.model.Scheduled).toSaveDate(),
            RequiredDate: new Date(this.model.Required).toSaveDate(),
            DateCompleted: this.model.DateCompleted
              ? new Date(this.model.DateCompleted).toSaveDate()
              : null,
            CompanyCode: this.model.CompanyCode,
            BranchCode: this.model.Branch,
            DivisionCode: this.model.Division,
            BomCode: this.model.BomCode,
            ProductCode: this.model.Product,
            Comment: this.model.Comments,
            ItemQty: this.model.Quantity.roundNumber(4),
            Username: UserService.getUsername(),
            WorkOrderSalesOrderLines: [],
            WorkOrderAddIns: [],
            MTSQty: this.model.MTSQuantity.roundNumber(4),
            Status: this.Status,
            WorkOrderProcesses: [],
            WorkOrderMaterials: [],
            WorkOrderShiftAllocations: [],
          };

          if (this.IsTimeFeatureVisible) {
            let {
              TotalSortHour,
              TotalTegraHour,
              TotalLabourHour,
              TotalDownTimeHour,
              DownTimeComment,
            } = this.workOrderTimeDataSource._array[0];

            payload.WorkOrderTime = {
              TotalSortHour,
              TotalTegraHour,
              TotalLabourHour,
              TotalDownTimeHour,
              DownTimeComment,
            };
          }

          // if (this.saveAsDraft) payload.Status = "D";
          // else payload.Status = "A";

          // Getting the instance like this results in an error because at a time there is only one grid instance is available (SS). Therefore changing the logic
          // to handle the selected rows data for the so line grid with a IsSelected data field.

          // let instance = this.$refs["wo-so-line-grid"].instance;
          // if (instance) {
          //   selectedRowsData = instance.getSelectedRowsData();
          // }

          let selectedRowsData = this.soLinesDataSource._array.filter(
            (x) => x.IsSelected,
          );

          let mtsLine = this.mtsDataSource._array.filter(
            (x) => x.ItemCode && x.StockUMQuantity >= 0,
          );

          let soLines = selectedRowsData.filter(
            (x) => x.SalesOrderCode !== 0 && x.SalesOrderLine !== 0,
          );

          if (this.$refs["wo-add-in-grid"]) {
            let instance = this.$refs["wo-add-in-grid"].instance;
            if (instance) await instance.saveEditData();
          }

          if (this.$refs["wo-so-line-grid"]) {
            let instance = this.$refs["wo-so-line-grid"].instance;
            if (instance) await instance.saveEditData();
          }

          soLines.map((item, index) => {
            let lineItem = {
              WorkOrderCode: this.model.Code,
              SalesOrderCode: item.SalesOrderCode || 0,
              SalesOrderLine: item.SalesOrderLine || 0,
              SalesOrderStockUMQuantity: item.StockUMQuantity,
              Position: index + 1,
              SalesOrderSalesUMQuantity: item.SalesUMQuantity,
              Note: item.Note,
            };

            payload.WorkOrderSalesOrderLines.push(lineItem);
          });

          mtsLine.map((item, index) => {
            let lineItem = {
              WorkOrderCode: this.model.Code,
              SalesOrderCode: item.SalesOrderCode || 0,
              SalesOrderLine: item.SalesOrderLine || 0,
              SalesOrderStockUMQuantity: item.StockUMQuantity,
              Position: index + 1,
              ItemCode: item.ItemCode,
              // SalesOrderSalesUMQuantity: item.SalesOrderSalesUMQuantity,
              Note: item.Note,
            };

            payload.WorkOrderSalesOrderLines.push(lineItem);
          });

          // selectedRowsData = [];
          // instance = this.$refs["wo-add-in-grid"].instance;
          // if (instance) {
          //   selectedRowsData = instance.getSelectedRowsData();
          // }
          let addInlines = this.addInDataSource._array.filter(
            (x) =>
              x.AddInSalesUMQty >= 0 &&
              x.AddInStockUMQty >= 0 &&
              x.ItemCode !== "",
          );

          addInlines.map((item) => {
            let lineItem = {
              WorkOrderCode: this.model.Code,
              ProductCode: item.ItemCode,
              SalesUM: item.SalesUM,
              StockUM: item.StockUM,
              SalesOrderLine: item.SalesOrderLine,
              AddInStockUMQty: item.AddInStockUMQty.roundNumber(4),
              AddInSalesUMQty: item.AddInSalesUMQty.roundNumber(4),
              RecordId: item.RecordId,
            };

            payload.WorkOrderAddIns.push(lineItem);
          });

          const processLines = this.$refs["process-tab-grid-component"]
            ? await this.$refs["process-tab-grid-component"].getProcessLines()
            : [];

          if (processLines.length > 0) {
            payload.WorkOrderProcesses = processLines;
          }

          const materialLines = this.$refs["materials-tab-grid-component"]
            ? await this.$refs[
                "materials-tab-grid-component"
              ].getMaterialLines()
            : [];

          if (materialLines.length > 0) {
            payload.WorkOrderMaterials = materialLines;
          }

          const sheduleLines = this.$refs["scheduling-tab-grid-component"]
            ? await this.$refs[
                "scheduling-tab-grid-component"
              ].getScheduleLines()
            : [];

          if (sheduleLines.length > 0) {
            // payload.WorkOrderSchedules = sheduleLines;
            const errors = [];
            const getErrorLines = []; // Validation disabled as per new requirement, keeping the code for future use

            // validate if scheduleLines have duplicate StartDate and ProcessCode and if yes the show validation error and return
            const duplicateCheckMap = new Map();
            let duplicateScheduleAllocationFound = false;
            sheduleLines.forEach((line) => {
              const key = `${line.ProcessCode}-${line.ScheduledStart}`;
              if (duplicateCheckMap.has(key)) {
                duplicateScheduleAllocationFound = true;
                duplicateCheckMap.set(key, duplicateCheckMap.get(key) + 1);
              } else {
                duplicateCheckMap.set(key, 1);
              }
            });

            if (
              this.isScheduleTabEditable &&
              duplicateScheduleAllocationFound
            ) {
              await this.$alert(
                "Some schedule entries have identical scheduled start time. Please adjust the timings before saving.",
                "Invalid Schedule",
              );
              this.$nextTick(() => {
                if (this.selectedTabIndex !== this.getTabIndex("Schedule")) {
                  this.selectedTabIndex = this.getTabIndex("Schedule");
                }
              });
              return;
            }

            // this.validateProcessDurationsArray(
            //   sheduleLines,
            // ).filter((x) => x.isValid === false);

            if (getErrorLines.length > 0 && this.isScheduleTabEditable) {
              getErrorLines.forEach((line) => {
                errors.push(
                  `Total scheduled time for ${line.ProcessCode} does not match required process time. Please adjust splits so total equals ${line.expectedTotal}.`,
                );
              });

              await this.$alert(errors.join("</br>"), "Validation Error");
              this.$nextTick(() => {
                if (this.selectedTabIndex !== this.getTabIndex("Schedule")) {
                  this.selectedTabIndex = this.getTabIndex("Schedule");
                }
              });
              return;
            } else {
              sheduleLines.map((item) => {
                let lineItem = {
                  ProcessCode: item.ProcessCode,
                  ProcessDescription: item.ProcessDescription,
                  StartDate: item.ScheduledStart
                    ? new Date(item.ScheduledStart).toSaveDateTime()
                    : null,
                  EndDate: item.ScheduledEnd
                    ? new Date(item.ScheduledEnd).toSaveDateTime()
                    : null,
                  DurationMinutes: item.DurationMins,
                  WorkOrderCode: this.model.Code,
                  RecordId: item.RecordId,
                };

                payload.WorkOrderShiftAllocations.push(lineItem);
              });
            }
          }

          try {
            this.showLoading(true);
            const result = await WorkOrderService.save(payload);

            if (result && result.data) {
              const savedWorkOrder = result.data;
              const RequiredDate = new Date(savedWorkOrder.RequiredDate);
              const ScheduledDate = new Date(savedWorkOrder.ScheduledDate);

              if (savedWorkOrder.SchedulingMethod === "Manual") {
                if (
                  this.popupConfig.formMode === "edit" &&
                  (this.isRequiredDateChanged ||
                    this.isQuantityChanged ||
                    this.isProcessTabChanged)
                ) {
                  await this.$alert(
                    "The Work Order schedule has not been updated. Please adjust process schedules in the Schedule tab.",
                    "Information",
                  );
                } else if (
                  this.popupConfig.formMode === "edit" &&
                  savedWorkOrder.ProcessOverlapErrorExists
                ) {
                  await this.$alert(
                    "One or more schedule entries overlap either within this work order or with the schedule of another work order. Please review the schedule to ensure it aligns with your operational requirements.",
                    "Information",
                  );
                } else if (this.popupConfig.formMode === "create") {
                  await this.$alert(
                    "Scheduling has not been generated because this BOM is set to Manual. Please go to Edit Mode and specify scheduling in the Scheduling tab.",
                    "Information",
                  );
                }
              } else {
                const wasRescheduled =
                  this.popupConfig.formMode === "create" ||
                  ScheduledDate.toDateString() !==
                    new Date(this.model.Scheduled).toDateString();

                if (
                  RequiredDate.toDateString() !== ScheduledDate.toDateString() &&
                  wasRescheduled
                ) {
                  await this.$alert(
                    `Work Order #${
                      savedWorkOrder.Code
                    } has been created and rescheduled to ${ScheduledDate.toDateString()} due to unavailable capacity on the required date.`,
                    "Information",
                  );
                }
              }
            }

            if (
              this.popupConfig.formMode === "create" &&
              this.model.SchedulingMethod === "Manual"
            ) {
              this.popupConfig.workOrderCode = result.data.Code;
              this.popupConfig.displayForScheduleEditing = true;
              this.saveCallBack();
            } else if (!BOMUpdate) {
              this.$notify(
                `Work order #${result.data.Code} is successfully ${
                  this.popupConfig.formMode === "create" ? "created" : "updated"
                }`,
                "success",
              );
            } else {
              this.$notify(`BOM has been updated successfully.`, "success");
            }
            this.showLoading(false);

            if (!BOMUpdate) {
              this.saveCallBack();
            } else {
              this.refreshData();
            }
          } catch (e) {
            this.saveAsDraft = false;
            this.showLoading(false);
            this.displayServerError(e, "Save Failed");

            if (e.data && e.data.WorkOrderProcessSaveResponse) {
              if (
                e.data.WorkOrderProcessSaveResponse
                  .DeleteFailedWorkOrderProcesses &&
                e.data.WorkOrderProcessSaveResponse
                  .DeleteFailedWorkOrderProcesses.length > 0
              ) {
                if (this.$refs["process-tab-grid-component"]) {
                  this.$refs[
                    "process-tab-grid-component"
                  ].updateDeletedProcessLines(
                    e.data.WorkOrderProcessSaveResponse
                      .DeleteFailedWorkOrderProcesses,
                  );
                }
              } else if (
                e.data.WorkOrderProcessSaveResponse
                  .DeleteFailedWorkOrderMaterials &&
                e.data.WorkOrderProcessSaveResponse
                  .DeleteFailedWorkOrderMaterials.length > 0
              ) {
                if (this.$refs["materials-tab-grid-component"]) {
                  this.$refs[
                    "materials-tab-grid-component"
                  ].updateDeletedMaterialLines(
                    e.data.WorkOrderProcessSaveResponse
                      .DeleteFailedWorkOrderMaterials,
                  );
                }
              }
            }
          }
        }
      }
    },

    async refreshData() {
      this.refreshOnUpdate = true;
      this.getWorkOrderHeaderSummary(this.popupConfig.workOrderCode);
      const response = await WorkOrderService.getByCode(
        this.popupConfig.workOrderCode,
      );

      if (response && response.data && response.data.value) {
        const dataModel = response.data.value[0];
        this.workOrderTimeDataSource.insert({
          Code: dataModel.Code,
          TotalSortHour: dataModel.TotalSortHour,
          TotalTegraHour: dataModel.TotalTegraHour,
          TotalLabourHour: dataModel.TotalLabourHour,
          TotalDownTimeHour: dataModel.TotalDownTimeHour,
          DownTimeComment: dataModel.DownTimeComment,
        });
      }

      // Failsafe timeout to reset refreshOnUpdate
      setTimeout(() => {
        this.refreshOnUpdate = false;
      }, 2000);
    },
    onProcessTabEditingStart() {
      this.isProcessTabChanged = true;
    },

    /**
     * Set Focus on Field
     * @param dataField
     */
    setFocusOnField(dataField, isSection1 = true, isSection2 = false) {
      this.saveAsDraft = false;

      if (this.popupConfig.formMode !== "review") {
        if (
          isSection1 &&
          this.$refs["gc-header-form"] &&
          this.$refs["gc-header-form"].$refs["gc-form-comp"]
        ) {
          this.$refs["gc-header-form"].$refs["gc-form-comp"].instance
            .getEditor(dataField)
            .focus();
        } else if (
          isSection2 &&
          this.$refs["gc-header-form-comment"] &&
          this.$refs["gc-header-form-comment"].$refs["gc-form-comp"]
        ) {
          this.$refs["gc-header-form-comment"].$refs["gc-form-comp"].instance
            .getEditor(dataField)
            .focus();
        }
      }
    },

    /**
     * on Cancel Popup Handler
     */
    async onCancelPopupHandler() {
      if (this.popupConfig.isPopupShow) {
        let confirm = true;

        if (this.popupConfig.formMode !== "review") {
          confirm = await this.$confirm(
            `You have unsaved changes. Are you sure you want to leave?`,
            "Unsaved changes",
            {
              confirmButtonText: "Yes",
              cancelButtonText: "No",
              type: "warning",
            },
          );
        }
        if (confirm) {
          this.$store.dispatch("hotKey/setHotKeyPopupMode", false);
          if (this.popupConfig.formMode === "create") {
            this.popupConfig.isPopupShow = false;
          } else {
            this.popupConfig.hideOnOutsideClick = true;
            this.popupConfig.formMode = "review";
            this.popupConfig.formKey++;
            this.popupConfig.isPopupShow = false;

            // await this.resetEditedData();
          }
        }
      }
    },

    async resetEditedData() {
      let workOrderDetail = this.dataModel;

      this.model.QuoteCode = workOrderDetail.QuoteCode;
      this.model.Comments = workOrderDetail.Comment;
      this.model.Quantity = workOrderDetail.ItemQty;
      this.model.Required = workOrderDetail.ShipDate;
      this.model.Scheduled = workOrderDetail.ScheduledDate;
    },

    /**
     * On Copy Work Order
     */
    async onCopyWorkOrderHandler() {
      await this.resetSummaries();
      this.resetAndRefreshHeaderTotals();
      if (this.IsAddInFeatureEnabled) {
        await this.addInDataSource.clear();

        this.addNewLineIntoProductEntry();
      }
      // this.mtsDataSource.clear();
      await this.soLinesDataSource.clear();
      await this.workOrderTimeDataSource.clear();
      if (this.$refs["materials-tab-grid-component"]) {
        this.$refs[
          "materials-tab-grid-component"
        ].workOrderMaterialDataSource.clear();
      }

      if (this.$refs["process-tab-grid-component"]) {
        this.$refs["process-tab-grid-component"].processDataSource.clear();
      }
      this.model.Quantity -= this.model.SOQuantity;
      this.model.SOQuantity = 0;
      this.dataModel.FriendlyStatus = "Draft";
      this.FriendlyStatus = "Draft";
      this.Status = "D";

      this.popupConfig.formMode = "copy";
      await this.getWorkOrderStatus();

      if (this.RetainMTSLinesOnCopy == "N") {
        this.mtsDataSource.clear();
      } else {
        this.addMTSLineOnCopy();
      }

      this.addNewLineIntoMTS();

      if (this.$refs["wo-so-line-grid"]) {
        let dataGrid = this.$refs["wo-so-line-grid"].instance;
        dataGrid.refresh();
      }

      this.$nextTick(async () => {
        this.calculateAddInHeaderValues();
        this.model.Required = new Date();
        this.model.Scheduled = new Date();
        this.model.QuoteCode = 0;
        // this.FriendlyStatus = undefined;
        this.popupConfig.title = "Create Work Order";
        this.popupConfig.secondaryTitle = undefined;
        this.popupConfig.hideOnOutsideClick = false;
        this.popupConfig.formKey++;
        this.popupConfig.isEditable = true;

        if (this.getDataGridInstance) {
          this.getDataGridInstance.refresh();
        }

        this.$nextTick(() => {
          this.selectedTabIndex = this.getTabIndex("Make to Stock");
          setTimeout(() => {
            this.focusOnEditableCell(0, "StockUMQuantity");
          }, 1);
        });
      });
    },
    async addMTSLineOnCopy() {
      if (
        this.mtsDataSource._array.length === 0 &&
        this.MTSQuantityForCopy != 0
      ) {
        await this.addMTSLineFromProduct(
          { ProductCode: this.model.Product },
          this.MTSQuantityForCopy,
        );
      }
    },

    /**
     * On Cancel Work Order
     */
    async onCancelWorkOrderHandler() {
      let confirmCancel = await this.$confirm(
        "Do you want to cancel this work order?",
        "Cancel Work Order",
      );

      if (confirmCancel) {
        this.onCancelWorkOrder();
      }
    },
    async onCancelWorkOrder() {
      this.showLoading(true);
      await WorkOrderService.cancelWorkOrder({
        Code: this.dataModel.Code.toString(),
        DateChanged: new Date().toISOString().replace("Z", ""),
      })
        .then((res) => {
          if (res)
            this.$notify(
              `Work Order #${this.dataModel.Code} Successfully Cancelled`,
              "success",
            );
          this.showLoading(false);
          this.saveCallBack();
        })
        .catch((err) => {
          this.showLoading(false);
          this.displayServerError(err, "Cancel Work Order Failed");
        });
    },

    /**
     * On Reopen Work Order Handler
     */
    async onReopenWorkOrderHandler() {
      let confirmReOrder = await this.$confirm(
        "Do you want to re-open this work order?",
        "Re-Open Work Order",
      );

      if (confirmReOrder) {
        this.showLoading(true);
        await WorkOrderService.reopenWorkOrder({
          Code: this.dataModel.Code.toString(),
          DateChanged: new Date().toISOString().replace("Z", ""),
        })
          .then((res) => {
            if (res)
              this.$notify(
                `Work Order #${this.dataModel.Code} Successfully Re-Opened.`,
                "success",
              );
            this.showLoading(false);
            this.saveCallBack();
          })
          .catch((err) => {
            this.showLoading(false);
            this.displayServerError(err, "Re-Open Work Order Failed");
          });
      }
    },

    /**
     * On Complete Work Order Handler
     */
    async onCompleteWorkOrderHandler() {
      let confirmComplete = await this.$confirm(
        "Do you want to complete this work order?",
        "Complete Work Order",
      );

      if (confirmComplete) {
        this.onCompleteWorkOrder();
      }
    },

    async onCompleteWorkOrder() {
      this.showLoading(true);
      await WorkOrderService.completeWorkOrder({
        Code: this.dataModel.Code.toString(),
        DateChanged: new Date().toISOString().replace("Z", ""),
      })
        .then((res) => {
          if (res)
            this.$notify(
              `Work Order #${this.dataModel.Code} Successfully Completed`,
              "success",
            );
          this.showLoading(false);
          this.saveCallBack();
        })
        .catch((err) => {
          this.showLoading(false);
          this.displayServerError(err, "Complete Work Order Failed");
        });
    },

    /**
     * on so list grid toolbar preparing
     * @param e - event
     */
    onToolbarPreparing(e) {
      e.toolbarOptions.visible = false;
    },

    /**
     * add selected so list from so model to wo model
     * @param soItems - selected items
     */
    addSelectedSoLines(soItems) {
      let IDs = [];

      soItems.forEach((element) => {
        if (element.SalesUMQty) element.SalesUMQuantity = element.SalesUMQty;
        if (element.StockUMQty) element.StockUMQuantity = element.StockUMQty;

        element.SalesOrderShipDate = new Date(element.ShipDate);

        element.IsSelected = true;
        this.soLinesDataSource.insert(element).then(() => {
          IDs.push({
            SalesOrderCode: element.SalesOrderCode,
            SalesOrderLine: element.SalesOrderLine,
          });
        });
      });

      // sort the data source based on ShipDate ascending
      this.soLinesDataSource._array.sort((a, b) => {
        return new Date(a.SalesOrderShipDate) - new Date(b.SalesOrderShipDate);
      });

      setTimeout(() => {
        this.$nextTick(() => {
          if (!this.$refs["wo-so-line-grid"]) return;
          let instance = this.$refs["wo-so-line-grid"].instance;
          if (instance)
            instance.refresh().then(() => {
              instance.selectRows(IDs, true);
            });
        });
      }, 10);
    },

    // eslint-disable-next-line no-unused-vars
    async onAddInSelectionChanged(e) {
      this.calculateAddInHeaderValues();
    },

    /**
     * WO model so list grid item selected
     */
    async onSoListSelectionChanged(e) {
      await (async () => {
        for (const element of e.selectedRowsData) {
          if (element.Refetch && element.SalesOrderCode !== 0) {
            const res = await WorkOrderService.getWorkOrderSalesOrderDetailLine(
              element.SalesOrderCode,
              element.SalesOrderLine,
            );
            if (res.data.value.length > 0) {
              element.StockUMQuantity = res.data.value[0].StockUMBackorderQty;
              element.SalesUMQuantity = res.data.value[0].SalesUMBackorderQty;
              element.IsSelected = true;
              element.Refetch = false;
            }
          }
        }
      })();

      this.selectedRowsData = e.selectedRowsData;
      let currentDeselectedRowKeys = e.currentDeselectedRowKeys;

      if (currentDeselectedRowKeys.length > 0) {
        currentDeselectedRowKeys.forEach((element) => {
          if (element.SalesOrderCode !== 0)
            this.soLinesDataSource.update(
              {
                SalesOrderCode: element.SalesOrderCode,
                SalesOrderLine: element.SalesOrderLine,
              },
              {
                IsSelected: false,
                Refetch: true,
              },
            );
        });
      }

      let Quantity = 0;
      let SOQuantity = 0;
      let MTSQuantity = this.mtsDataSource._array.reduce(
        (prev, curr) => prev + curr.StockUMQuantity,
        0.0,
      );

      const calculateQuantities = (rows) => {
        const mtsLines = this.mtsDataSource._array.filter(
          (x) => x.StockUMQuantity > 0,
        );
        const soLines = rows.filter(
          (x) => x.SalesOrderCode !== 0 && x.SalesOrderLine !== 0,
        );

        const MTSQuantity = mtsLines.reduce(
          (prev, curr) => prev + curr.StockUMQuantity,
          0.0,
        );
        const SOQuantity = soLines.reduce(
          (prev, curr) => prev + curr.StockUMQuantity,
          0.0,
        );

        return { MTSQuantity, SOQuantity };
      };

      if (this.popupConfig.formMode === "edit") {
        ({ MTSQuantity, SOQuantity } = calculateQuantities(e.selectedRowsData));

        if (SOQuantity === 0 && MTSQuantity === 0) {
          if (
            this.selectedBOMData &&
            this.selectedBOMData.BatchSize > SOQuantity
          ) {
            // Quantity = this.selectedBOMData.BatchSize;
            // MTSQuantity = Quantity - SOQuantity;
          }
        } else {
          Quantity = MTSQuantity + SOQuantity;
        }
      } else {
        if (this.selectedRowsData.length > 0) {
          SOQuantity = this.selectedRowsData.reduce(
            (prev, curr) => prev + curr.StockUMQuantity,
            0.0,
          );

          if (
            this.selectedBOMData &&
            this.selectedBOMData.BatchSize > SOQuantity
          ) {
            // Quantity = this.selectedBOMData.BatchSize;
          } else {
            Quantity = this.model.MTSQuantity + SOQuantity;
          }

          // MTSQuantity = Quantity - SOQuantity;
        } else {
          if (this.selectedBOMData && this.selectedBOMData.BatchSize > 0) {
            // Quantity = this.selectedBOMData.BatchSize;
          } else {
            Quantity = 0;
          }
          // MTSQuantity = Quantity;
        }
      }

      if (
        Quantity < this.model.ReleasedQty &&
        this.dataModel.FriendlyStatus === "In Production"
      ) {
        if (MTSQuantity === 1) MTSQuantity = 0;
        Quantity = this.model.ReleasedQty + MTSQuantity;
      }

      if (this.popupConfig.formMode !== "review") {
        this.model.Quantity = Quantity;
        this.model.MTSQuantity = MTSQuantity;
        this.model.SOQuantity = SOQuantity;

        this.updateHeaderSection2Values();
      }
    },
    updateFormValues(dataField, value) {
      const form = this.$refs["gc-header-form"].$refs["gc-form-comp"].instance;
      form.beginUpdate();
      form.updateData(dataField, value);
      form.endUpdate();
    },

    calculateAddInHeaderValues() {
      let addInStockUMQty = 0;
      let addInSalesUMQty = 0;

      this.addInDataSource._array.forEach((element) => {
        if (element.AddInStockUMQty > 0) {
          addInStockUMQty += element.AddInStockUMQty;
        }
      });

      addInSalesUMQty = (
        addInStockUMQty / this.AddInSalesUMConversion
      ).roundNumber(4);

      if (this.popupConfig.formMode !== "review") {
        this.model.AddInStockUMQuantity = addInStockUMQty;
        this.model.AddInSalesUMQuantity = addInSalesUMQty;
        this.updateHeaderSection2Values();
      }
    },

    onContentReady(e) {
      if (this.selectedTabIndex === this.getTabIndex("Make to Stock")) {
        this.addGridNoResults(e, {
          addNew: {
            class: "add-new",
            title: "No Make to Stock Items",
            message:
              "There are no Make to Stock items linked to this work order",
          },
        });
      } else if (this.selectedTabIndex === this.getTabIndex("Add In")) {
        this.addGridNoResults(e, {
          addNew: {
            class: "add-new",
            title: "No Add In",
            message: "Select Products to Add In to this Work Order",
          },
        });
      } else if (this.selectedTabIndex === this.getTabIndex("Sales Orders")) {
        this.addGridNoResults(e, {
          addNew: {
            class: "add-new",
            title: "No Sales Orders",
            message: "No orders linked with this Work Order",
          },
        });
      } else if (this.selectedTabIndex === this.getTabIndex("Releases")) {
        this.addGridNoResults(e, {
          addNew: {
            class: "add-new",
            title: "No Releases",
            message: "No Production Release has been made to this Work Order",
          },
        });
      }
      this.setModelItemHeights();
      this.$nextTick(() => {
        this.reSizeGrid(e.component);
      });
    },

    /**
     * WO Qty value changed
     * @param e - event
     */
    async onQuantityValueChanged(e) {
      if (!e.event) return;

      const showAlertAndReset = async (message, field) => {
        await this.$alert(message, "Validation Error");
        e.component.beginUpdate();
        e.component.option("value", e.previousValue);
        e.component.endUpdate();
        this.setFocusOnField(field);
      };

      if (
        this.addInDataSource._array.length > 0 &&
        this.getTotalAddInQty > e.value
      ) {
        await showAlertAndReset(
          "You have attempted to set the WO Quantity to less than the add-in line total. Please enter a WO Quantity that is greater than or equal to add-in total",
          "Quantity",
        );
      } else if (this.model.SOQuantity === 0 && e.value === 0) {
        await showAlertAndReset(
          "You have attempted to set the WO Quantity to 0.0000. Please enter a WO Quantity that is greater than 0.0000",
          "Quantity",
        );
      } else if (this.model.SOQuantity > 0 && e.value < this.model.SOQuantity) {
        await showAlertAndReset(
          `You have attempted to set the WO Quantity below the selected Sales Order Quantity. Please enter a WO Quantity that is greater than or equal to ${this.model.SOQuantity}.`,
          "Quantity",
        );
      } else {
        this.model.MTSQuantity = e.value - this.model.SOQuantity;
      }
    },
    /**
     * MTS Qty value changed
     * @param e - event
     */
    async onMTSQuantityValueChanged(e) {
      let previousQtyValue = this.model.Quantity;
      this.model.Quantity = e.value + this.model.SOQuantity;

      if (this.model.Quantity === 0) {
        await this.$alert(
          "You have attempted to set the WO Quantity to 0.0000. Please enter a MTS Quantity that is greater than 0.0000",
          "Validation Error",
        );
        this.updateQtyFieldFromMTSQty(e, previousQtyValue);
      } else if (
        this.model.SOQuantity > 0 &&
        this.model.Quantity < this.model.SOQuantity
      ) {
        await this.$alert(
          `You have attempted to set the WO Quantity below the selected Sales Order Quantity. Please enter a WO Quantity that is greater than or equal to  ${this.model.SOQuantity}.`,
          "Validation Error",
        );

        this.updateQtyFieldFromMTSQty(e, previousQtyValue);
      } else {
        if (e.value === 0) {
          let instance = this.$refs["wo-so-line-grid"].instance;
          if (instance) {
            instance
              .byKey({
                SalesOrderCode: 0,
                SalesOrderLine: 0,
              })
              .then((res) => {
                if (res) {
                  instance.deselectRows([
                    {
                      SalesOrderCode: 0,
                      SalesOrderLine: 0,
                    },
                  ]);
                }
              });
          }
        }
      }
    },

    updateQtyFieldFromMTSQty(e, previousQtyValue) {
      e.component.beginUpdate();
      e.component.option("value", e.previousValue);
      e.component.endUpdate();

      this.model.Quantity = previousQtyValue;
      this.setFocusOnField("MTSQuantity");
    },

    onBOMSelectionChanged(e) {
      if (this.popupConfig.formMode !== "create") {
        this.selectedBOMData = e.selectedItem;
      }
      this.model.SchedulingMethod = e.selectedItem
        ? e.selectedItem.SchedulingMethod
        : "Continuous Flow";
    },

    async onProductSelectionChanged(e) {
      if (e.selectedItem) {
        this.selectedProdData = { ...e.selectedItem };

        if (this.popupConfig.formMode !== "review") {
          this.ProductionSummary.StockUM =
            this.selectedProdData.UnitOfMeasureCode;

          // this.resetAndRefreshHeaderTotals();
        }
      } else this.selectedProdData = undefined;

      if (this.IsAddInFeatureEnabled) this.setAddInProdFilter();
      this.setMTSProdFilter();
    },
    async setAddInProdFilter() {
      this.addInProdFilter = [];
      this.addInProdFilter.push(["IsDefault", "=", "Y"]);
      // this.addInProdFilter.push("and");
      // this.addInProdFilter.push(["Available", ">", 0]);

      let settingValue = await SettingsService.getBySettingName(
        "WorkOrderAddInFinishedGoodType",
      );

      if (settingValue.data.value.length > 0) {
        this.addInProdFilter.push("and");

        // check if setting value has comma separated values and split them
        if (settingValue.data.value[0].SettingValue.includes(",")) {
          const values = settingValue.data.value[0].SettingValue.split(",");
          var additionalFilters = [];
          values.forEach((value) => {
            additionalFilters.push(["ProductTypeCode", "=", value.trim()]);
            additionalFilters.push("or");
          });

          // remove the last "or" from the additionalFilters array
          additionalFilters.pop();

          this.addInProdFilter.push(additionalFilters);
        } else if (settingValue.data.value[0].SettingValue !== "") {
          // if not comma separated, just use the single value
          this.addInProdFilter.push([
            "ProductTypeCode",
            "=",
            settingValue.data.value[0].SettingValue,
          ]);
        }
      }

      let settingValue2 = await SettingsService.getBySettingName(
        "WorkOrderAddInFinishedGoodAssociation",
      );

      let filter = [];

      if (
        settingValue2.data.value.length > 0 &&
        this.selectedProdData !== undefined
      ) {
        const SettingValue = settingValue2.data.value[0].SettingValue;

        const categoryMap = {
          "Product Category 1": "ProductCategory1Code",
          "Product Category 2": "ProductCategory2Code",
          "Product Category 3": "ProductCategory3Code",
          "Product Category 4": "ProductCategory4Code",
        };

        if (
          categoryMap[SettingValue] &&
          this.selectedProdData[categoryMap[SettingValue]]
        ) {
          filter.push([
            categoryMap[SettingValue],
            "=",
            this.selectedProdData[categoryMap[SettingValue]],
          ]);
        }
      }

      if (filter.length > 0) {
        this.addInProdFilter.push("and");
        this.addInProdFilter.push(filter[0]);
      }

      if (this.model.Branch) {
        if (this.addInProdFilter.length > 0) this.addInProdFilter.push("and");
        this.addInProdFilter.push(["BranchCode", "=", this.model.Branch]);
      }

      if (!this.$refs["wo-add-in-grid"]) return;

      let dataGrid = this.$refs["wo-add-in-grid"].instance;
      let columns = dataGrid.option("columns");
      columns[0].editorOptions.dataSource = WorkOrderService.dataSourceConfig(
        "api/WorkOrderAddInItemCompanyBranch",
        {
          filter: this.addInProdFilter,
          postProcess: (data) => {
            // remove item when ItemCode is equal to this.PrimaryProductData.ItemCode from data array
            if (this.primaryProductData) {
              data = data.filter(
                (x) => x.ItemCode !== this.primaryProductData.ItemCode,
              );
            }

            // add this.PrimaryProductData to the data array as the first item
            if (this.primaryProductData) {
              data.unshift(this.primaryProductData);
            }

            return data;
          },
        },
      );
      dataGrid.option("columns", columns);
    },
    async setMTSProdFilter() {
      let prodFilter = [];
      prodFilter.push(["Source", "=", "M"]);
      prodFilter.push("and");
      prodFilter.push(["Inactive", "=", "N"]);

      let settingValue = await SettingsService.getBySettingName(
        "WorkOrderMTSProductAssociation",
      );

      let filter = [];

      if (
        settingValue.data.value.length > 0 &&
        this.selectedProdData !== undefined
      ) {
        const SettingValue = settingValue.data.value[0].SettingValue;

        const categoryMap = {
          "Product Category 1": "ProductCategory1Code",
          "Product Category 2": "ProductCategory2Code",
          "Product Category 3": "ProductCategory3Code",
          "Product Category 4": "ProductCategory4Code",
          "Product Type": "ProductTypeCode",
          "Product Size": "ProductSizeCode",
        };

        if (
          categoryMap[SettingValue] &&
          this.selectedProdData[categoryMap[SettingValue]]
        ) {
          filter.push([
            categoryMap[SettingValue],
            "=",
            this.selectedProdData[categoryMap[SettingValue]],
          ]);
        } else {
          for (let i = 1; i <= 20; i++) {
            const formattedAttribute = `Attribute ${i
              .toString()
              .padStart(2, "0")}`;
            if (
              SettingValue === formattedAttribute &&
              this.selectedProdData[formattedAttribute]
            ) {
              filter.push([
                formattedAttribute,
                "=",
                this.selectedProdData[formattedAttribute],
              ]);
              break;
            }
          }
        }
      }

      if (filter.length > 0) {
        prodFilter.push("and");
        prodFilter.push(filter[0]);
      }

      if (!this.$refs["mts-grid"]) return;

      let dataGrid = this.$refs["mts-grid"].instance;
      let columns = dataGrid.option("columns");
      columns[0].editorOptions.dataSource = WorkOrderService.dataSourceConfig(
        "api/Product",
        {
          filter: prodFilter,
          postProcess: (data) => {
            // remove item when ItemCode is equal to this.PrimaryProductData.ItemCode from data array
            if (this.primaryProductData) {
              data = data.filter(
                (x) => x.Code !== this.primaryProductData.ItemCode,
              );
            }

            // add this.PrimaryProductData to the data array as the first item
            if (this.primaryProductData) {
              this.primaryProductData["Code"] =
                this.primaryProductData.ItemCode;

              data.unshift(this.primaryProductData);
            }

            data.forEach((element) => {
              if (element.Code) element.ItemCode = element.Code;
            });

            return data;
          },
        },
      );
      dataGrid.option("columns", columns);
    },
    onProductCodeSelected(e) {
      let itemData = e.selectedItem;
      if (!itemData) return;
      let index = this.productDataSourceItems.findIndex(
        (x) => x.ItemCode === itemData.ItemCode,
      );
      if (index === -1) {
        this.productDataSourceItems.push(itemData);
      }
    },
    isActualCompletionInTabSequence() {
      return (
        this.WorkOrderInstance === "Almondco" &&
        (this.popupConfig.formMode === "review" ||
          this.popupConfig.formMode === "edit") &&
        !this.isActualCompletionReadOnly
      );
    },
    onRequiredDown(e) {
      if (forwardTabbing(e)) {
        e.event.preventDefault();
        if (this.isActualCompletionInTabSequence()) {
          this.setFocusOnField("DateCompleted", true, false);
        } else {
          this.setFocusOnField("Comments", false, true);
        }
      }
    },
    onActualCompletionDown(e) {
      if (forwardTabbing(e)) {
        e.event.preventDefault();
        this.setFocusOnField("Comments", false, true);
      } else if (backwardTabbing(e)) {
        e.event.preventDefault();
        this.setFocusOnField("Required", true, false);
      }
    },
    onCommentKeyDown(e) {
      if (e.event.keyCode == 9 && !e.event.shiftKey) {
        e.event.preventDefault();
        if (
          this.selectedTabIndex === this.getTabIndex("Add In") ||
          this.selectedTabIndex === this.getTabIndex("Make to Stock")
        ) {
          this.focusOnEditableCell(0, "ItemCode");
        } else if (this.selectedTabIndex === this.getTabIndex("Sales Orders")) {
          if (this.soLinesDataSource._array.length > 0) {
            this.focusOnEditableCell(0, "Note");
          }
        } else if (this.selectedTabIndex === this.getTabIndex("Processes")) {
          const instance =
            this.$refs["process-tab-grid-component"].$refs["process-tab-grid"]
              .instance;
          if (instance) {
            const dataSource = instance.option("dataSource");
            if (dataSource && dataSource.length > 0) {
              const firstRow = dataSource[0];
              if (firstRow) {
                if (firstRow.IsDeletable === "Y") {
                  this.$refs["process-tab-grid-component"].focusOnEditableCell(
                    0,
                    "ProcessCode",
                  );
                } else {
                  this.$refs["process-tab-grid-component"].focusOnEditableCell(
                    0,
                    "RatePerHour",
                  );
                }
              }
            }
          }
        } else if (this.selectedTabIndex === this.getTabIndex("Materials")) {
          const instance =
            this.$refs["materials-tab-grid-component"].$refs[
              "materials-tab-grid"
            ].instance;

          if (instance) {
            const dataSource = instance.option("dataSource");
            if (dataSource && dataSource.length > 0) {
              const firstRow = dataSource[0];
              if (firstRow) {
                if (firstRow.IsEditable) {
                  this.$refs[
                    "materials-tab-grid-component"
                  ].focusOnEditableCell(0, "ProcessCode");
                } else {
                  this.$refs[
                    "materials-tab-grid-component"
                  ].focusOnEditableCell(0, "WorkOrderQty");
                }
              }
            }
          }
        } else if (this.selectedTabIndex === this.getTabIndex("Schedule")) {
          const instance =
            this.$refs["scheduling-tab-grid-component"].$refs[
              "scheduling-tab-grid"
            ].instance;

          if (instance) {
            const dataSource = instance.option("dataSource");
            if (dataSource && dataSource.length > 0) {
              this.$refs["scheduling-tab-grid-component"].focusOnEditableCell(
                0,
                "ProcessCode",
              );
            }
          }
        }
      } else if (backwardTabbing(e)) {
        e.event.preventDefault();
        if (this.isActualCompletionInTabSequence()) {
          this.setFocusOnField("DateCompleted", true, false);
        } else {
          this.setFocusOnField("Required", true, false);
        }
      }
    },
    onItemCodeKeyDown(e, lineData) {
      if (e.event.keyCode == 9 && e.event.shiftKey && lineData.rowIndex == 0) {
        e.event.preventDefault();
        // If the first row is focused and shift + tab is pressed, focus on the comments field
        this.setFocusOnField("Comments", false, true);
      }
    },
    onItemCodeClick(e, lineData) {
      let dataField = "AddInStockUMQty";
      if (this.selectedTabIndex === this.getTabIndex("Make to Stock"))
        dataField = "StockUMQty";
      if (e) this.focusOnEditableCell(lineData.rowIndex, dataField);
    },

    commentFieldHeightUpdate(e) {
      let instance = e.component;
      let count = countLineBreaks(instance.instance().option().value);
      if (count < 7) {
        if (count > 2) {
          instance.instance().beginUpdate();
          instance.instance().option("height", count * 16);
          instance.instance().endUpdate();
          this.getDataGridInstance.updateDimensions();
        }
      } else {
        instance.instance().beginUpdate();
        instance.instance().option("height", 250);
        instance.instance().endUpdate();
        this.getDataGridInstance.updateDimensions();
      }
    },

    onProdQtyClicked(e) {
      this.releasePopupInfo.dataModel = e.data;
      this.releasePopupInfo.isPopupShow = true;
    },

    getTabIndex(text) {
      return this.getTabViews.findIndex((x) => x.text === text);
    },
    onStatusValueChanged(e) {
      if (e.event) {
        this.Status = e.value;
      }
    },
    StatusInitialized(e) {
      let instance = e.component;
      instance.instance().beginUpdate();
      instance.instance().option("value", this.Status);
      instance.instance().endUpdate();

      this.StatusComponent = e;
    },

    // Add New Release
    async onAddNewRelease() {
      this.HotKeyWatcherEnabled = false;
      this.releaseModelInfo.dataModel.BranchCode = this.model.Branch;
      this.releaseModelInfo.dataModel.WorkOrderCode = this.model.Code;

      this.releaseModelInfo.isPopupShow = true;
    },
    /**
     * On Add New Material Issue
     */
    async onAddNewMaterialIssue() {
      this.HotKeyWatcherEnabled = false;
      this.issueModelInfo.dataModel.BranchCode = this.model.Branch;
      this.issueModelInfo.dataModel.WorkOrderCode = this.model.Code;

      this.issueModelInfo.isPopupShow = true;
    },

    async focusOutFromEditableCells() {
      var dataGrid = this.getDataGridInstance;
      const activeElement = document.activeElement;
      if (activeElement) {
        activeElement.blur();
        if (dataGrid) dataGrid.saveEditData();
      }
    },

    getFormattedQty(value) {
      return formatNumber(value, "##,###,###,###,##0.0000");
    },

    async getWorkOrderHeaderSummary(code) {
      try {
        const response = await WorkOrderService.getWorkOrderHeaderSummary(
          code,
          this.WorkOrderInstance,
        );
        if (response && response.data) {
          this.ProductionSummary = response.data.ProductionSummary;
          this.MaterialSummary = response.data.MaterialSummary;
        }

        this.resetAndRefreshHeaderTotals(true);
      } catch (error) {
        this.displayServerError(error, "Failed to fetch Work Order Summary");
      } finally {
        if (this.WorkOrderInstance === "Core") {
          this.getWorkOrderCostSummary(code);
        }
      }
    },

    async getWorkOrderCostSummary(code) {
      try {
        const response = await WorkOrderService.getWorkOrderCostSummary(code);
        if (response && response.data && response.data.value.length > 0) {
          this.CostSummary = response.data.value[0];
        }
      } catch (error) {
        this.displayServerError(
          error,
          "Failed to fetch Work Order Cost Summary",
        );
      } finally {
        this.resetAndRefreshHeaderTotals(true);
      }
    },

    resetAndRefreshHeaderTotals(refresh = false) {
      this.headerSection2DataSource.clear();
      this.headerSection3DataSource.clear();
      this.headerSection3Part2DataSource.clear();

      this.$nextTick(async () => {
        await this.setHeaderSection2DataSource();
        await this.setHeaderSection3DataSource();
        const section2Instance = this.$refs["header-section-2-grid"];
        if (section2Instance && section2Instance.instance) {
          if (refresh) {
            section2Instance.instance.refresh(true);
          } else {
            section2Instance.instance.repaint();
          }
          setTimeout(() => {
            section2Instance.instance.updateDimensions();
          }, 100);
        }

        const section3Instance = this.$refs["header-section-3-grid"];
        if (section3Instance && section3Instance.instance) {
          if (refresh) {
            section3Instance.instance.refresh(true);
          } else {
            section3Instance.instance.repaint();
          }
          setTimeout(() => {
            section3Instance.instance.updateDimensions();
          }, 100);
        }

        const section3Part2Instance = this.$refs["header-section-3-part2-grid"];
        if (section3Part2Instance && section3Part2Instance.instance) {
          if (refresh) {
            section3Part2Instance.instance.refresh(true);
          } else {
            section3Part2Instance.instance.repaint();
          }
        }
      });
    },

    onHeaderSection2CellPrepared(e) {
      if (e && e.rowType === "data") {
        if (e.rowIndex > 2) {
          e.cellElement.style.fontWeight = "bold";
        }

        if (
          e.rowIndex === 5 ||
          (e.rowIndex === 6 && this.WorkOrderInstance === "Core")
        ) {
          if (
            (e.columnIndex === 1 && e.data.Variance > 0) ||
            (e.columnIndex === 2 && e.data.VariancePercentage > 0)
          ) {
            e.cellElement.style.color = "#079455";
          } else if (
            (e.columnIndex === 1 && e.data.Variance < 0) ||
            (e.columnIndex === 2 && e.data.VariancePercentage < 0)
          ) {
            e.cellElement.style.color = "red";
          }
        }
      }
    },
    onHeaderSection3CellPrepared(e) {
      if (e && e.rowType === "data") {
        if (this.WorkOrderInstance === "Core") {
          if (e.rowIndex === 2) {
            e.cellElement.style.fontWeight = "bold";
          }

          if (e.columnIndex === 3 || e.columnIndex === 4) {
            if (e.value > 0) {
              e.cellElement.style.color = "#079455";
            } else if (e.value < 0) {
              e.cellElement.style.color = "red";
            }
          }
        } else {
          if (e.rowIndex === 7) {
            e.cellElement.style.fontWeight = "bold";
          }

          if (e.rowIndex === 7) {
            if (
              (e.columnIndex === 1 && e.data.Weight > 0) ||
              (e.columnIndex === 2 && e.data.Value > 0)
            ) {
              e.cellElement.style.color = "#079455";
            } else if (
              (e.columnIndex === 1 && e.data.Weight < 0) ||
              (e.columnIndex === 2 && e.data.Value < 0)
            ) {
              e.cellElement.style.color = "red";
            }
          }
        }
      }
    },
    onHeaderSection3Part2CellPrepared(e) {
      if (e && e.rowType === "data") {
        if (e.columnIndex === 3 || e.columnIndex === 4) {
          if (e.value > 0) {
            e.cellElement.style.color = "#079455";
          } else if (e.value < 0) {
            e.cellElement.style.color = "red";
          }
        }
      }
    },
    setModelItemHeights() {
      this.$nextTick(() => {
        const popupHeight = document.querySelector(
          ".gc-popup-work-order .dx-overlay-content.dx-popup-normal.dx-resizable",
        ).clientHeight;
        const toolBarHeight = document.querySelector(
          ".gc-popup-work-order .dx-toolbar.dx-widget.dx-visibility-change-handler.dx-collection.dx-popup-title",
        ).clientHeight;

        let headerHeight = document.querySelector(
          ".dx-popup-content .css-v2.gc-popup-form",
        ).clientHeight;

        if (this.IsGridExpanded) {
          headerHeight = 0;
        }

        this.gridHeight = popupHeight - toolBarHeight - headerHeight - 60;
      });
    },

    // id Popup Config
    onAddNewReleaseAndIssuesBulk() {
      if (this.dataModel.CustomerStopCredit === "Y") {
        this.$alert(
          "The Customer linked to this Work Order is on Stop Credit. \nYou may not process any transactions against this Work Order while the Customer is on Stop Credit.",
          "Customer Stop Credit",
        );
      } else {
        this.HotKeyWatcherEnabled = false;
        this.bulkPopupConfig.dataModel.WorkOrderCode = this.model.Code;
        this.bulkPopupConfig.isPopupShow = true;
      }
    },

    async onExpandGrid() {
      this.IsGridExpanded = !this.IsGridExpanded;
      await this.$nextTick();

      setTimeout(() => {
        this.$nextTick(() => {
          this.setModelItemHeights();
          const dataGridInstance = this.getDataGridInstance;
          if (dataGridInstance) {
            this.reSizeGrid(dataGridInstance);
          }
        });
      }, 100);
    },

    async onRequiredDateChanged(e) {
      const { formMode } = this.popupConfig;
      const newDate = new Date(e.value).toSaveDate();
      const today = new Date().toSaveDate();

      if (newDate !== this.initialRequiredDate) {
        this.isRequiredDateChanged = true;
      }

      // Only proceed if new date is in the past
      if (newDate < today) {
        let message;

        if (formMode === "create" || formMode === "copy") {
          message = `You are attempting to create a Work Order with a Required Date of ${new Date(
            e.value,
          ).toShortDateString()}. Are you sure you wish to proceed with this?`;
        } else if (formMode === "edit") {
          message = `You are attempting to edit Work Order #${
            this.model.Code
          } and set the Required Date to ${new Date(
            e.value,
          ).toShortDateString()}. Are you sure you wish to proceed with this?`;
        } else {
          return; // No confirmation needed for other modes
        }

        const confirmDate = await this.$confirm(
          message,
          "Confirm Required Date",
        );

        if (!confirmDate) {
          e.component.beginUpdate();
          e.component.option("value", e.previousValue);
          e.component.endUpdate();
          this.setFocusOnField("Required");
          this.isRequiredDateChanged = false;
        }
      }
    },
  },
  computed: {
    isActualCompletionReadOnly() {
      return (
        this.dataModel.FriendlyStatus === "Draft" ||
        this.dataModel.FriendlyStatus === "Awaiting Production" ||
        this.dataModel.FriendlyStatus === "Planning"
      );
    },
    IsTimeFeatureVisible() {
      return (
        this.IsTimeFeatureEnabled &&
        this.popupConfig.formMode !== "create" &&
        this.popupConfig.formMode !== "copy"
      );
    },
    getDataModelForIssuesTab() {
      return {
        WorkOrderCode: this.dataModel.Code,
        BranchCode: this.dataModel.Branch,
        WorkOrderStatus: this.dataModel.FriendlyStatus,
      };
    },
    getAddNewOptions() {
      return [
        {
          text: "Sales Order Line",
          onClick: this.setSoLineModel,
          visible: this.getAddSOLineBtnVisibility,
        },
        {
          text: "Issue",
          visible:
            this.popupConfig.formMode !== "create" &&
            this.getAddNewVisibilityStatus,
          disabled: !FeatureStorage.checkPermission(
            "WorkOrderMaterialIssue",
            "create",
          ),
          onClick: this.onAddNewMaterialIssue,
        },
        {
          text: "Release",
          visible:
            this.popupConfig.formMode !== "create" &&
            this.getAddNewVisibilityStatus,
          disabled: !FeatureStorage.checkPermission(
            "WorkOrderProductionRelease",
            "create",
          ),
          onClick: this.onAddNewRelease,
        },
        {
          text: "Release & Bulk Issue",
          visible:
            this.popupConfig.formMode !== "create" &&
            this.getAddNewVisibilityStatus &&
            FeatureStorage.checkPermission(
              "WorkOrderReleaseAndIssueBulk",
              "create",
            ),
          // disabled: FeatureStorage.checkPermission(
          //   "WorkOrderReleaseAndIssueBulk",
          //   "create"
          // ),
          onClick: this.onAddNewReleaseAndIssuesBulk,
        },
      ];
    },
    getAddNewVisibilityStatus() {
      return (
        this.dataModel.FriendlyStatus === "Awaiting Production" ||
        this.dataModel.FriendlyStatus === "In Production" ||
        this.dataModel.FriendlyStatus === "Review"
      );
    },
    getTabViews() {
      const formMode = this.popupConfig.formMode;
      const isFormEditable = formMode !== "create" && formMode !== "copy";

      return [
        { id: 0, text: "Make to Stock" },
        {
          id: 1,
          text: "Add In",
          visible: this.IsAddInFeatureEnabled,
        },
        { id: 2, text: "Sales Orders" },
        {
          id: 3,
          text: "Processes",
          visible: this.isWorkOrderProcessesTabVisible && isFormEditable,
        },
        {
          id: 4,
          text: "Schedule",
          visible: this.isScheduleTabVisible,
        },
        {
          id: 5,
          text: "Materials",
          visible: this.isWorkOrderMaterialsTabVisible && isFormEditable,
        },
        {
          id: 6,
          text: "Time",
          visible: this.IsTimeFeatureVisible && isFormEditable,
        },
        {
          id: 7,
          text: "Issues",
          visible: isFormEditable,
        },
        {
          id: 8,
          text: "Releases",
          visible: this.FriendlyStatus !== "Draft",
        },
      ];
    },
    isScheduleTabVisible() {
      return this.popupConfig.formMode !== "create";
    },
    isScheduleTabEditable() {
      return (
        this.popupConfig.formMode !== "create" &&
        this.model.SchedulingMethod === "Manual"
      );
    },
    getReleaseColumns() {
      return this.parseColumnWithScreenFields([
        {
          caption: "Product",
          dataField: "ProductCode",
          width: ColumnWidth.Code.width,
          minWidth: ColumnWidth.Code.minWidth,
          alignment: "left",
          allowSorting: true,
        },
        {
          caption: "Description",
          dataField: "ProductDescription",
          minWidth: ColumnWidth.Description.minWidth,
          alignment: "left",
          allowSorting: true,
        },
        {
          caption: "Batch No",
          dataField: "BatchNo",
          minWidth: ColumnWidth.BatchNo.minWidth,
          alignment: "left",
          allowSorting: true,
        },
        {
          screenField: "ShipDate",
          caption: "Release Date",
          dataField: "ReleaseDate",
          minWidth: ColumnWidth.Date.minWidth + 10,
          width: ColumnWidth.Date.width + 10,
          format: "dd MMM yyyy",
          allowSorting: true,
        },
        {
          screenField: "SalesUM",
          caption: "Production UM",
          dataField: "ProductionUM",
          minWidth: ColumnWidth.ProductionUnitOfMeasure.minWidth,
          width: ColumnWidth.ProductionUnitOfMeasure.width,
          allowSorting: true,
        },
        {
          screenField: "Quantity",
          dataField: "ProductionUMQty",
          caption: "Production UM Qty",
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          width: ColumnWidth.Quantity4DecimalPoints.width,
          cellTemplate: "product-um-template",
          allowSorting: true,
        },
        {
          screenField: "StockUM",
          caption: "Stock UM",
          minWidth: ColumnWidth.UnitOfMeasure.minWidth - 5,
          width: ColumnWidth.UnitOfMeasure.width - 5,
          allowSorting: true,
        },
        {
          screenField: "Quantity",
          dataField: "StockUMQty",
          caption: "Stock UM Qty",
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          width: ColumnWidth.Quantity4DecimalPoints.width,
          allowSorting: true,
          cellTemplate: "product-um-template",
        },
      ]);
    },
    ReleaseDataSource() {
      return WorkOrderService.dataSourceConfig(
        this.WorkOrderInstance === "Core"
          ? "api/ProductionReleaseDetailGrouped"
          : "api/AlmondcoProductionReleaseDetailSummary",
        {
          filter: `WorkOrderCode eq ${this.dataModel.Code}`,
        },
      );
    },
    getDataGridInstance() {
      if (this.selectedTabIndex === this.getTabIndex("Make to Stock")) {
        return this.$refs["mts-grid"].instance;
      } else if (this.selectedTabIndex === this.getTabIndex("Add In")) {
        return this.$refs["wo-add-in-grid"].instance;
      } else if (this.selectedTabIndex === this.getTabIndex("Sales Orders")) {
        return this.$refs["wo-so-line-grid"].instance;
      } else if (this.selectedTabIndex === this.getTabIndex("Time")) {
        return this.$refs["wo-time-grid"].instance;
      } else if (this.selectedTabIndex === this.getTabIndex("Materials")) {
        return this.$refs["materials-tab-grid-component"].dataGrid;
      } else if (this.selectedTabIndex === this.getTabIndex("Processes")) {
        return this.$refs["process-tab-grid-component"].dataGrid;
      } else return false;
    },
    ...mapGetters({ getHotKeySave: "hotKey/getHotKeySave" }),
    getVisible() {
      if (this.popupConfig.isPopupShow) return this.popupConfig.isPopupShow;
      else return false;
    },

    getHeaderFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 1,
          items: [
            {
              screenField: "BOM",
              dataField: "BomCode",
              required: true,
              label: {
                text: "BOM",
              },
              editorOptions: {
                showClearButton: true,
                readOnly: !this.isBOMEditable,
                tabIndex: this.popupConfig.formMode === "edit" ? -1 : 1,
                onValueChanged: this.onBomValueChanged,
                select: [
                  "Code",
                  "Comment",
                  "Description1",
                  "Description2",
                  "ProductCode",
                  "BatchSize",
                  "BranchCode",
                  "DivisionCode",
                  "BomTypeCode",
                  "Status",
                  "SchedulingMethod",
                ],
                onSelectionChanged: (e) => {
                  this.onBOMSelectionChanged(e);
                },
                onFocusIn: (e) => {
                  e.event.target.select();
                },
              },
              displayExpr: (e) => {
                if (e) return `${e.Code} - ${e.Description1}`;
                else return undefined;
              },
              searchExpr: [
                "Code",
                "Description1",
                "Description2",
                "ProductCode",
              ],
              filter:
                this.popupConfig.formMode === "edit"
                  ? ["ProductCode", "=", this.PrimaryProduct]
                  : undefined,
            },
            {
              screenField: "Product",
              dataField: "Product",
              allowUpdate: true,
              editorOptions: {
                readOnly: true,
                tabIndex: -1,
                onSelectionChanged: this.onProductSelectionChanged,
              },
              displayExpr: (e) => {
                if (e) return `${e.Code} - ${e.Description1}`;
                else undefined;
              },
            },
            {
              screenField: "Branch",
              dataField: "Branch",
              required: true,
              label: {
                text: "Branch",
              },
              filter: ["ManufactureFlag", "=", "Y"],
              editorOptions: {
                tabIndex: -1,
                readOnly: !this.isBranchEditable,
              },
              displayExpr: (e) => {
                if (e) return `${e.Code} - ${e.Description}`;
                else undefined;
              },
            },
            {
              screenField: "Division",
              dataField: "Division",
              required: true,
              label: {
                text: "Division",
              },
              editorOptions: {
                tabIndex: -1,
                readOnly: !this.isDivisionEditable,
              },
              displayExpr: (e) => {
                if (e) return `${e.Code} - ${e.Description}`;
                else undefined;
              },
            },
            {
              screenField: "DateIn",
              dataField: "Required",
              label: {
                text: "Required",
              },
              format: "dd MMM yyyy",
              editorOptions: {
                showClearButton: true,
                tabIndex:
                  this.popupConfig.formMode === "edit" &&
                  this.dataModel.FriendlyStatus === "In Production"
                    ? -1
                    : 3,
                useMaskBehavior: true,
                onFocusIn: (e) => {
                  e.event.target.select();
                },
                readOnly:
                  this.popupConfig.formMode === "edit" &&
                  this.dataModel.FriendlyStatus === "In Production",
                onKeyDown: this.onRequiredDown,
                onValueChanged: (e) => {
                  if (!e.event || !e.value) return;
                  this.onRequiredDateChanged(e);
                },
              },
              required: true,
            },
            {
              visible: this.popupConfig.formMode === "review",
              screenField: "DateIn",
              dataField: "Scheduled",
              label: {
                text: "Scheduled",
              },
              format: "dd MMM yyyy",
              editorOptions: {
                tabIndex: 4,
                useMaskBehavior: true,
                onFocusIn: (e) => {
                  e.event.target.select();
                },
              },
              required: true,
            },
            {
              visible:
                this.popupConfig.formMode === "review" ||
                this.popupConfig.formMode === "edit",
              // screenField: "DateIn",
              dataField: "PlannedCompletionDate",
              label: {
                text: "Planned Completion",
              },
              displayFormat: "dd MMM yyyy H:mm aa",
              editorOptions: {
                tabIndex: 5,
                useMaskBehavior: true,
                readOnly: true,
                displayFormat: "dd MMM yyyy H:mm aa",
              },
              // required: true,
              type: "datetime",
              editorType: "dxDateBox",
            },
            {
              visible:
                this.WorkOrderInstance === "Almondco" &&
                (this.popupConfig.formMode === "review" ||
                  this.popupConfig.formMode === "edit"),
              dataField: "DateCompleted",
              label: {
                text: "Actual Completion",
              },
              displayFormat: "dd MMM yyyy",
              editorOptions: {
                showClearButton: true,
                tabIndex: 6,
                useMaskBehavior: true,
                readOnly:
                  this.popupConfig.formMode === "edit" &&
                  (this.dataModel.FriendlyStatus === "Draft" ||
                    this.dataModel.FriendlyStatus === "Awaiting Production" ||
                    this.dataModel.FriendlyStatus === "Planning"),
                displayFormat: "dd MMM yyyy",
                onFocusIn: (e) => {
                  e.event.target.select();
                },
                onKeyDown: this.onActualCompletionDown,
              },
              type: "datetime",
              editorType: "dxDateBox",
            },
            {
              visible: this.popupConfig.formMode === "review",
              label: {
                text: "Release Department",
              },
              dataField: "ReleaseDepartment",
            },
          ],
        },
      ];
    },
    getHeaderComment() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 1,
          items: [
            {
              dataField: "Comments",
              screenField: "Comments",
              allowUpdate: true,
              editorType: "dxTextArea",
              editorOptions: {
                tabIndex: 8,
                height: 80,
                maxLength: 1000,
                onFocusIn: (e) => {
                  e.event.target.select();
                },
                onKeyDown: this.onCommentKeyDown,
              },
            },
          ],
        },
      ];
    },
    isDivisionEditable() {
      return (
        this.popupConfig.formMode === "edit" &&
        (this.dataModel.FriendlyStatus === "Draft" ||
          this.dataModel.FriendlyStatus === "Awaiting Production" ||
          this.dataModel.FriendlyStatus === "Planning")
      );
    },
    isBOMEditable() {
      return (
        this.popupConfig.formMode === "create" ||
        (this.popupConfig.formMode === "edit" &&
          (this.dataModel.FriendlyStatus === "Draft" ||
            this.dataModel.FriendlyStatus === "Awaiting Production" ||
            this.dataModel.FriendlyStatus === "Planning"))
      );
    },
    isBranchEditable() {
      return (
        this.popupConfig.formMode === "edit" &&
        (this.dataModel.FriendlyStatus === "Draft" ||
          this.dataModel.FriendlyStatus === "Awaiting Production" ||
          this.dataModel.FriendlyStatus === "Planning")
      );
    },

    getToolbarItems() {
      // const isDraftVisible =
      //   ["create", "copy"].includes(this.popupConfig.formMode) ||
      //   (this.popupConfig.formMode !== "review" &&
      //     this.FriendlyStatus === "Draft");
      return [
        {
          widget: "dxButton",
          location: "after",
          toolbar: "center",
          visible: this.popupConfig.formMode === "review",
          cssClass: "status-template-2",
          options: {
            template: "wo-status-template",
            elementAttr: { class: "status-template" },
          },
        },
        {
          widget: "dxButton",
          location: "after",
          toolbar: "top",
          visible: false, // This work is being deferred at this time as legacy does not support background printing of work orders atm. #54380
          options: {
            icon: "print",
            // onClick: this.onBackGrounPrintRequest,
          },
        },
        {
          location: "after",
          toolbar: "top",
          visible: this.popupConfig.formMode === "review",
          template: "screen-pdf-view",
        },
        {
          widget: "dxButton",
          location: "after",
          toolbar: "top",
          visible:
            this.popupConfig.formMode !== "create" &&
            this.popupConfig.formMode !== "copy",
          options: {
            icon: "clock",
            onClick: this.onAuditPopupHandler,
          },
        },
        {
          widget: "dxButton",
          location: "after",
          toolbar: "top",
          visible:
            this.popupConfig.formMode === "review" &&
            this.popupConfig.isEditable &&
            FeatureStorage.checkPermission(
              this.applicationFeatureCode,
              "create",
            ),
          options: {
            icon: "edit",
            onClick: this.onEditPopupHandler,
            visible:
              this.popupConfig.formMode === "review" &&
              this.popupConfig.isEditable,
          },
        },
        {
          widget: "dxSelectBox",
          location: "after",
          toolbar: "top",
          visible: this.popupConfig.formMode !== "review",
          options: {
            // text: "Draft",
            // stylingMode: "contained",
            // type: "normal",
            // onClick: this.onDraftSave,
            // visible: isDraftVisible,
            items: this.getStatusDataSource,
            displayExpr: "FriendlyStatus",
            valueExpr: "Code",
            // value: this.Status,
            readOnly: false,
            onValueChanged: this.onStatusValueChanged,
            onInitialized: this.StatusInitialized,
          },
        },
        {
          widget: "dxButton",
          location: "after",
          toolbar: "top",
          visible: this.popupConfig.formMode !== "review",
          options: {
            text: "Save",
            stylingMode: "contained",
            type: "default",
            onClick: this.onSavePopupHandler,
            visible: this.popupConfig.formMode !== "review",
          },
        },
        {
          widget: "dxDropDownButton",
          location: "after",
          toolbar: "top",
          visible:
            this.popupConfig.formMode !== "create" &&
            this.popupConfig.formMode !== "copy",
          options: {
            items: this.getToolbarMenuItems,
            icon: "fas fa-ellipsis-v",
            showArrowIcon: false,
            stylingMode: "text",
            onItemClick: this.onToolbarMenuItemOnClick,
            dropDownOptions: {
              minWidth: 90, // Set minimum width for dropdown items
            },
            displayExpr: "menuText",
            valueExpr: "menuText",
          },
        },
        {
          widget: "dxButton",
          location: "after",
          toolbar: "top",
          visible: true,
          options: {
            icon: "close",
            onClick: this.onCancelPopupHandler,
            visible: true,
          },
        },
      ];
    },
    getToolbarMenuItems() {
      return [
        {
          menuText: "Copy",
          visible: true, // pending discussions #54331
          onClick: this.onCopyWorkOrderHandler,
        },
        // { menuText: "Cancel", onClick: this.onCancelWorkOrderHandler }, // Remove #59851
        { menuText: "Reopen", onClick: this.onReopenWorkOrderHandler },
        // { menuText: "Complete", onClick: this.onCompleteWorkOrderHandler },  // Remove #59851
      ];
    },
    getMTSGridColumns() {
      return this.parseColumnWithScreenFields([
        {
          caption: "Product",
          minWidth: ColumnWidth.TransactionAccount.minWidth,
          width: ColumnWidth.TransactionAccount.width,
          dataField: "ItemCode",
          fixed: true,
          fixedPosition: "left",
          cssClass: "edit-cell-textbox-field",
          editorOptions: {
            dataSource: WorkOrderService.dataSourceConfig("api/Product", {
              filter: [],
            }),
            displayExpr: "Code",
            valueExpr: "Code",
            searchTimeout: 10,
            searchEnabled: true,
            searchExpr: ["Code", "Description1"],
            onFocusIn: (e) => {
              e.event.target.select();
              this.productCodeFocusIn(e);
            },
            itemTemplate: (data) => {
              return ` <div class="custom-auto-complete" id="${data.ItemCode}" >
                            <span class="auto-complete-primary">
                              ${data.ItemCode}
                            </span>
                            <span class="record-secondary gc-grid-code">
                              ${data.Description1}
                            </span>
                          </div>`;
            },
            dropDownOptions: {
              minWidth: 400,
            },
            onSelectionChanged: (e) => {
              this.onProductCodeSelected(e);
            },
            onKeyDown: this.onItemCodeKeyDown,
            onItemClick: this.onItemCodeClick,
          },
          setCellValue: (newData, value, currentRowData) => {
            newData.ItemCode = value;

            let item = this.productDataSourceItems.find(
              (x) => x.ItemCode === value,
            );

            // let allowedTotal = this.model.Quantity - this.getTotalAddInQty;

            if (item) {
              newData.ItemDescription = item.Description1;
              newData.SalesUM = item.SalesUM;
              newData.StockUM = item.StockUM || item.UnitOfMeasureCode;
              // newData.AddInStockUMQty = allowedTotal > item.Available ? item.Available : allowedTotal;
              newData.OnHand = item.OnHand;
              newData.OnHandSalesUMQty = item.OnHandSalesUMQty;
              newData.SalesUMConversion = item.SalesUMConversion;
              newData.RecordId = "00000000-0000-0000-0000-000000000000";
              newData.Available = item.Available;
              newData.AvailableSalesUMQty = item.AvailableSalesUMQty;
              newData.OriginalAvailable = item.Available;
              newData.OriginalAvailableSalesUMQty = item.AvailableSalesUMQty;
              newData.QtyValidation = true;

              if (newData.AddInStockUMQty === item.Available)
                newData.AddInSalesUMQty = item.AvailableSalesUMQty;
              else
                newData.AddInSalesUMQty = calculateSalesUMQty(
                  newData.AddInStockUMQty,
                  item.SalesUMConversion,
                );
            }

            if (!currentRowData.ItemCode) this.addNewLineIntoMTS();

            return newData;
          },
        },
        {
          caption: "Description",
          dataField: "ItemDescription",
          allowEditing: false,
          minWidth: ColumnWidth.Description.minWidth,
        },
        {
          caption: "Stock UM Qty",
          dataField: "StockUMQuantity",
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          width: ColumnWidth.Quantity4DecimalPoints.width,
          format: "##,###,###,###,##0.0000",
          allowEditing: true,
          cssClass: "edit-cell-numberbox-field",
          editorOptions: {
            format: "##,###,###,###,##0.0000",
            onFocusIn: (e) => {
              e.event.target.select();
            },
            min: 0,
          },
          setCellValue: async (newData, value, currentRowData) => {
            if (!currentRowData.ItemCode) {
              await this.$alert(
                "Please select a product before entering the quantity.",
                "warning",
              );
              newData.StockUMQuantity = currentRowData.StockUMQuantity;
              this.$nextTick(() => {
                var dataGrid = this.getDataGridInstance;
                const rowIndex = dataGrid.getRowIndexByKey(currentRowData.ID);

                if (rowIndex !== -1) {
                  setTimeout(() => {
                    this.focusOnEditableCell(rowIndex, "ItemCode");
                  }, 100);
                }
              });
            } else {
              newData.StockUMQuantity = value;
            }

            return newData;
          },
        },
        {
          screenField: "StockUM",
          caption: "Stock UM",
          minWidth: ColumnWidth.UnitOfMeasure.minWidth - 5,
          width: ColumnWidth.UnitOfMeasure.width - 5,
          allowSorting: true,
        },
        {
          caption: "Work Order Notes",
          dataField: "Note",
          minWidth: ColumnWidth.Comment.minWidth,
          cssClass: "edit-cell-textbox-field comment-text",
          editorOptions: {
            onFocusIn: (e) => {
              e.event.target.select();
            },
            // onKeyDown: this.onItemCodeKeyDown,
            maxLength: 1000,
            maxHeight: 103,
            height: 30,
            valueChangeEvent: "input",
            onInput: (e) => {
              this.commentFieldHeightUpdate(e);
            },
            onInitialized: (e) => {
              this.commentFieldHeightUpdate(e);
            },
          },
          customizeText: (e) => {
            if (e.value) return e.value.replaceAll("\n", "<br/>\r\n");
            else return "";
          },
          encodeHtml: false,
          cellTemplate: (data, info) => {
            return (data.innerHTML = `<div class='comment-cell-template'>${info.text}</div>`);
          },
          setCellValue: (newData, value) => {
            newData.Note = value;
            return newData;
          },
        },
        {
          dataField: "",
          caption: "",
          type: "buttons",
          visible: this.popupConfig.formMode !== "review",
          buttons: [
            {
              hint: "Copy Line",
              icon: "copy",
              visible: true,
              onClick: (e) => {
                this.addNewLineIntoMTS(e, "copy-line");
              },
            },
            "delete",
          ],
          fixed: true,
          fixedPosition: "right",
        },
      ]);
    },
    getAddInGridColumns() {
      return this.parseColumnWithScreenFields([
        {
          caption: "Product",
          dataField: "ItemCode",
          fixed: true,
          fixedPosition: "left",
          cssClass: "edit-cell-textbox-field",
          // allowSearch: this.popupConfig.formMode == "review",
          // allowSorting: this.popupConfig.formMode == "review",
          // allowEditing: this.popupConfig.formMode != "review",
          editorOptions: {
            dataSource: WorkOrderService.dataSourceConfig(
              "api/WorkOrderAddInItemCompanyBranch",
              {
                filter: [],
              },
            ),
            displayExpr: "ItemCode",
            valueExpr: "ItemCode",
            searchTimeout: 10,
            searchEnabled: true,
            searchExpr: ["ItemCode", "Description", "Description1"],
            onFocusIn: (e) => {
              e.event.target.select();
              this.productCodeFocusIn(e);
            },
            itemTemplate: (data) => {
              return ` <div class="custom-auto-complete" id="${data.ItemCode}" >
                            <span class="auto-complete-primary">
                              ${data.ItemCode}
                            </span>
                            <span class="record-secondary gc-grid-code">
                              ${data.Description1}
                            </span>
                          </div>`;
            },
            dropDownOptions: {
              minWidth: 400,
            },
            onSelectionChanged: (e) => {
              this.onProductCodeSelected(e);
            },
            onKeyDown: this.onItemCodeKeyDown,
            onItemClick: this.onItemCodeClick,
          },
          // eslint-disable-next-line no-unused-vars
          setCellValue: (newData, value, currentRowData) => {
            newData.ItemCode = value;

            let item = this.productDataSourceItems.find(
              (x) => x.ItemCode === value,
            );

            let allowedTotal = this.model.Quantity - this.getTotalAddInQty;

            if (item) {
              newData.ItemDescription = item.Description1;
              newData.SalesUM = item.SalesUM;
              newData.StockUM = item.StockUM;
              newData.AddInStockUMQty =
                allowedTotal > item.Available ? item.Available : allowedTotal;
              newData.OnHand = item.OnHand;
              newData.OnHandSalesUMQty = item.OnHandSalesUMQty;
              newData.SalesUMConversion = item.SalesUMConversion;
              newData.RecordId = "00000000-0000-0000-0000-000000000000";
              newData.Available = item.Available;
              newData.AvailableSalesUMQty = item.AvailableSalesUMQty;
              newData.OriginalAvailable = item.Available;
              newData.OriginalAvailableSalesUMQty = item.AvailableSalesUMQty;
              newData.QtyValidation = true;

              if (newData.AddInStockUMQty === item.Available)
                newData.AddInSalesUMQty = item.AvailableSalesUMQty;
              else
                newData.AddInSalesUMQty = calculateSalesUMQty(
                  newData.AddInStockUMQty,
                  item.SalesUMConversion,
                );
            }

            if (!currentRowData.ItemCode) this.addNewLineIntoProductEntry();

            return newData;
          },
          minWidth: ColumnWidth.TransactionAccount.minWidth,
          width: ColumnWidth.TransactionAccount.width,
        },
        {
          caption: "Description",
          dataField: "ItemDescription",
          allowEditing: false,
          minWidth: ColumnWidth.Description.minWidth,
        },

        {
          screenField: "StockUM",
          caption: "Stock UM",
          minWidth: ColumnWidth.UnitOfMeasure.minWidth - 5,
          width: ColumnWidth.UnitOfMeasure.width - 5,
          allowSorting: true,
        },

        // StockUM on hand
        // {
        //   screenField: "Quantity",
        //   dataField: "OnHand",
        //   caption: "On Hand",
        //   minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
        //   width: ColumnWidth.Quantity4DecimalPoints.width,
        //   allowSorting: true,
        // },
        {
          screenField: "Quantity",
          dataField: "Available",
          caption: "Available",
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          width: ColumnWidth.Quantity4DecimalPoints.width,
          allowSorting: true,
        },
        // StockUM Add In
        {
          dataField: "AddInStockUMQty",
          caption: "Add In",
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          width: ColumnWidth.Quantity4DecimalPoints.width,
          format: "##,###,###,###,##0.0000",
          allowEditing: true,
          cssClass: "edit-cell-numberbox-field",
          editorOptions: {
            format: "##,###,###,###,##0.0000",
            onFocusIn: (e) => {
              e.event.target.select();
              // this.addInDataSource.update(lineData.data.ID, {
              //   QtyValidation: true,
              // });
            },
            // onFocusOut: async (e, lineData) => {
            //   console.log(
            //     "A ## : ",
            //     lineData.data.QtyValidation,
            //     this.getTotalAddInQty
            //   );
            //   return;
            //   if (!e.event) return;

            //   if (lineData.data.QtyValidation) {
            //     if (this.getTotalAddInQty > this.model.Quantity) {
            //       let alert = await this.$alert(
            //         `Add In stock quantity total can not be greater than WO quantity`,
            //         "Validation Error"
            //       );

            //       if (alert) {
            //         this.addInDataSource.update(lineData.data.ID, {
            //           AddInStockUMQty: lineData.data.Available,
            //           AddInSalesUMQty: lineData.data.AvailableSalesUMQty,
            //           QtyValidation: false,
            //         });
            //         this.$nextTick(() => {
            //           this.reFocusOnQty(lineData.data, "AddInStockUMQty");
            //         });
            //       }
            //     }
            //   }
            // },
            // onInput: (e, lineData) => {
            //   console.log("onInput : ", e);
            //   if (e.event)
            //     this.addInDataSource.update(lineData.data.ID, {
            //       QtyValidation: true,
            //     });
            // },
            // to do update sales um qty
          },
          setCellValue: async (newData, value, currentRowData) => {
            // this.addInDataSource.update(currentRowData.ID, {
            //   QtyValidation: false,
            // });
            if (value < 0) {
              let alert = await this.$alert(
                `Add In stock quantity can not be less than 0.00`,
                "Validation Error",
              );
              if (alert) {
                newData.AddInStockUMQty = currentRowData.AddInStockUMQty;
                this.$nextTick(() => {
                  this.reFocusOnQty(currentRowData, "AddInStockUMQty");
                });
              }
            } else if (value > currentRowData.Available) {
              let alert = await this.$alert(
                `Add In stock quantity is greater than Available Add-In quantity.`,
                "Validation Error",
              );
              if (alert) {
                newData.AddInStockUMQty = currentRowData.AddInStockUMQty;
                this.$nextTick(() => {
                  this.reFocusOnQty(currentRowData, "AddInStockUMQty");
                });
              }
            } else if (
              value + this.getTotalAddInQty - currentRowData.AddInStockUMQty >
              this.model.Quantity
            ) {
              let alert = await this.$alert(
                `Add In stock quantity total can not be greater than WO quantity`,
                "Validation Error",
              );
              if (alert) {
                newData.AddInStockUMQty = currentRowData.AddInStockUMQty;
                setTimeout(() => {
                  this.$nextTick(() => {
                    this.reFocusOnQty(currentRowData, "AddInStockUMQty");
                  });
                }, 1);
              }
            } else {
              newData.QtyValidation = false;
              newData.AddInStockUMQty = value;
              newData.AddInSalesUMQty = calculateSalesUMQty(
                value,
                currentRowData.SalesUMConversion,
              );
            }
          },
        },

        {
          screenField: "SalesUM",
          caption: "Sales UM",
          minWidth: ColumnWidth.UnitOfMeasure.minWidth - 5,
          width: ColumnWidth.UnitOfMeasure.width - 5,
          allowSorting: true,
        },

        // SalesUM on hand
        // {
        //   screenField: "Quantity",
        //   dataField: "OnHandSalesUMQty",
        //   caption: "On Hand",
        //   minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
        //   width: ColumnWidth.Quantity4DecimalPoints.width,
        //   allowSorting: true,
        // },
        {
          screenField: "Available",
          dataField: "AvailableSalesUMQty",
          cpation: "Available",
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          width: ColumnWidth.Quantity4DecimalPoints.width,
          allowSorting: true,
        },

        // SalesUM add on
        {
          dataField: "AddInSalesUMQty",
          caption: "Add In",
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          width: ColumnWidth.Quantity4DecimalPoints.width,
          format: "##,###,###,###,##0.0000",
          allowEditing: true,
          cssClass: "edit-cell-numberbox-field",
          editorOptions: {
            format: "##,###,###,###,##0.0000",
            onFocusIn: (e) => {
              e.event.target.select();
            },
            // to do update stock um qty
          },
          setCellValue: async (newData, value, currentRowData) => {
            if (value < 0) {
              let alert = await this.$alert(
                `Add In sales quantity can not be less than 0.00`,
                "Validation Error",
              );
              if (alert) {
                newData.AddInSalesUMQty = currentRowData.AddInSalesUMQty;
                this.$nextTick(() => {
                  this.reFocusOnQty(currentRowData, "AddInSalesUMQty");
                });
              }
            } else if (value > currentRowData.AvailableSalesUMQty) {
              let alert = await this.$alert(
                `Add In sales quantity is greater than Available Add-In quantity.`,
                "Validation Error",
              );
              if (alert) {
                newData.AddInSalesUMQty = currentRowData.AddInSalesUMQty;
                this.$nextTick(() => {
                  this.reFocusOnQty(currentRowData, "AddInSalesUMQty");
                });
              }
            } else {
              let stockQty = calculateStockUMQty(
                value,
                currentRowData.SalesUMConversion,
              );

              if (
                stockQty -
                  currentRowData.AddInStockUMQty +
                  this.getTotalAddInQty >
                this.model.Quantity
              ) {
                let alert = await this.$alert(
                  `Add In stock quantity total can not be greater than WO quantity`,
                  "Validation Error",
                );
                if (alert) {
                  newData.AddInSalesUMQty = currentRowData.AddInSalesUMQty;
                  setTimeout(() => {
                    this.$nextTick(() => {
                      this.reFocusOnQty(currentRowData, "AddInSalesUMQty");
                    });
                  }, 10);
                }
              } else {
                newData.AddInSalesUMQty = value;
                newData.AddInStockUMQty = calculateStockUMQty(
                  value,
                  currentRowData.SalesUMConversion,
                );
              }
            }
          },
        },
        {
          dataField: "",
          caption: "",
          type: "buttons",
          visible: this.popupConfig.formMode !== "review",
          buttons: [
            {
              hint: "Add Line",
              icon: "plus",
              visible: true,
              onClick: () => {
                this.addNewLineIntoProductEntry(false, "new-line");
              },
            },
            // "delete",
            {
              hint: "Delete",
              icon: "trash",

              visible: (e) => {
                const data = e.row.data;
                if (
                  data &&
                  data.IsDeletable === "Y" &&
                  this.popupConfig.formMode !== "review"
                ) {
                  return true;
                } else {
                  return false;
                }
              },
              onClick: async (e) => {
                var dataGrid = this.$refs["wo-add-in-grid"].instance;
                dataGrid.deleteRow(e.row.rowIndex);
              },
            },
          ],
          fixed: true,
          fixedPosition: "right",
        },
      ]);
    },
    getSalesGridColumns() {
      return this.parseColumnWithScreenFields([
        {
          caption: "Sales Order",
          dataField: "SalesOrderCode",
          width: ColumnWidth.SalesOrderNumber.width - 10,
          minWidth: ColumnWidth.SalesOrderNumber.minWidth - 10,
          alignment: "left",
          allowEditing: false,
        },
        {
          screenField: "Customer",
          allowSorting: true,
        },
        {
          screenField: "LineComment",
          caption: "Line #",
          dataField: "SalesOrderLine",
          width: ColumnWidth.LineInfo.width - 20,
          minWidth: ColumnWidth.LineInfo.minWidth - 20,
          alignment: "left",
          allowSorting: true,
        },
        {
          screenField: "ShipDate",
          dataField: "SalesOrderShipDate",
          minWidth: ColumnWidth.Date.minWidth,
          width: ColumnWidth.Date.width,
          format: "dd MMM yyyy",
          allowSorting: true,
        },
        {
          screenField: "Product",
          caption: "Product",
          allowSorting: true,
        },
        {
          screenField: "Quantity",
          dataField: "ProductionUMQuantity",
          caption: "Production UM Qty",
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          width: ColumnWidth.Quantity4DecimalPoints.width,
          allowSorting: true,
        },
        {
          screenField: "ProductionUM",
          dataField: "ProductionUM",
          caption: "Production UM",
          minWidth: ColumnWidth.UnitOfMeasure.minWidth + 10,
          width: ColumnWidth.UnitOfMeasure.width + 10,
          allowSorting: true,
        },
        {
          screenField: "Quantity",
          dataField: "StockUMQuantity",
          caption: "Stock UM Qty",
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          width: ColumnWidth.Quantity4DecimalPoints.width,
          allowSorting: true,
        },
        {
          screenField: "StockUM",
          caption: "Stock UM",
          minWidth: ColumnWidth.UnitOfMeasure.minWidth - 5,
          width: ColumnWidth.UnitOfMeasure.width - 5,
          allowSorting: true,
        },
        {
          caption: "",
          dataField: "",
          type: "selection",
          fixed: true,
          fixedPosition: "right",
          visible: this.getAddSOLineBtnVisibility,
          width: 30,
          minWidth: 30,
        },
        {
          screenField: "Comment",
          dataField: "SalesOrderNote",
          caption: "Sales Order Notes",
          // cssClass: "edit-cell-textbox-field comment-text",
          editorOptions: {
            maxLength: 1000,
            maxHeight: 103,
            height: 30,
            readOnly: true,

            // onInitialized: (e) => {
            //   this.commentFieldHeightUpdate(e);
            // },
          },
          minWidth: ColumnWidth.Comment.minWidth,
          width: ColumnWidth.Comment.width,
          customizeText: (e) => {
            if (e.value) return e.value.replaceAll("\n", "<br/>\r\n");
            else return "";
          },
          encodeHtml: false,
          cellTemplate: (data, info) => {
            return (data.innerHTML = `<div class='comment-cell-template'>${info.text}</div>`);
          },
        },
        {
          screenField: "Comment",
          dataField: "Note",
          caption: "Work Order Notes",
          cssClass: "edit-cell-textbox-field comment-text",
          editorOptions: {
            onFocusIn: (e) => {
              e.event.target.select();
            },
            onKeyDown: this.onItemCodeKeyDown,
            maxLength: 1000,
            maxHeight: 103,
            height: 30,
            valueChangeEvent: "input",
            onInput: (e) => {
              this.commentFieldHeightUpdate(e);
            },
            onInitialized: (e) => {
              this.commentFieldHeightUpdate(e);
            },
          },
          minWidth: ColumnWidth.Comment.minWidth,
          width: ColumnWidth.Comment.width,
          customizeText: (e) => {
            if (e.value) return e.value.replaceAll("\n", "<br/>\r\n");
            else return "";
          },
          encodeHtml: false,
          cellTemplate: (data, info) => {
            return (data.innerHTML = `<div class='comment-cell-template'>${info.text}</div>`);
          },
          setCellValue: (newData, value) => {
            newData.Note = value;
            return newData;
          },
        },
        {
          screenField: "TransportStatus",
          width: 100,
          customBackGroundColor: (data) => {
            if (data && data.TransportStatusHexColour)
              return data.TransportStatusHexColour;
            else return undefined;
          },
        },
      ]);
    },
    getEditableDecimalCommonProps() {
      return {
        width: ColumnWidth.Quantity2DecimalPoints.width,
        minWidth: ColumnWidth.Quantity2DecimalPoints.minWidth,
        allowSorting: true,
        format: "##,###,###,###,##0.00",
        allowEditing: true,
        cssClass: "edit-cell-numberbox-field",
        editorOptions: {
          min: 0,
          format: "##,###,###,###,##0.00",
          onFocusIn: (e) => {
            e.event.target.select();
          },
        },
      };
    },
    getWorkOrderTimeColumns() {
      return this.parseColumnWithScreenFields([
        {
          ...this.getEditableDecimalCommonProps,
          caption: "Hand Sort",
          dataField: "TotalSortHour",
          setCellValue: async (newData, value) => {
            newData.TotalSortHour = value;
            return newData;
          },
        },

        {
          ...this.getEditableDecimalCommonProps,
          caption: "Electronic Sort",
          dataField: "TotalTegraHour",
          setCellValue: async (newData, value) => {
            newData.TotalTegraHour = value;
            return newData;
          },
        },
        {
          ...this.getEditableDecimalCommonProps,
          caption: "Labour",
          dataField: "TotalLabourHour",
          setCellValue: async (newData, value) => {
            newData.TotalLabourHour = value;
            return newData;
          },
        },
        {
          ...this.getEditableDecimalCommonProps,
          caption: "Past / Blanch",
          dataField: "TotalDownTimeHour",
          setCellValue: async (newData, value) => {
            newData.TotalDownTimeHour = value;
            return newData;
          },
        },
        {
          caption: "Downtime Comment",
          dataField: "DownTimeComment",
          minWidth: ColumnWidth.Comment.minWidth,
          cssClass: "edit-cell-textbox-field comment-text",
          editorOptions: {
            onFocusIn: (e) => {
              e.event.target.select();
            },
            // onKeyDown: this.onItemCodeKeyDown,
            maxLength: 100,
            maxHeight: 103,
            height: 30,
            valueChangeEvent: "input",
            onInput: (e) => {
              this.commentFieldHeightUpdate(e);
            },
            onInitialized: (e) => {
              this.commentFieldHeightUpdate(e);
            },
          },
          customizeText: (e) => {
            if (e.value) return e.value.replaceAll("\n", "<br/>\r\n");
            else return "";
          },
          encodeHtml: false,
          cellTemplate: (data, info) => {
            return (data.innerHTML = `<div class='comment-cell-template'>${info.text}</div>`);
          },
          setCellValue: (newData, value) => {
            newData.DownTimeComment = value;
            return newData;
          },
        },
      ]);
    },

    getMTSDataSource() {
      return this.mtsDataSource;
    },

    getStatusDataSource() {
      return this.StatusDataSource;
    },

    /**
     * Data Grid
     * @returns {ArrayStore<*, any>}
     */
    getAddInLocalDataSource() {
      return this.addInDataSource;
    },

    /**
     * Data Grid
     * @returns {ArrayStore<*, any>}
     */
    getLocalDataSource() {
      return this.soLinesDataSource;
    },

    getAddSOLineBtnVisibility() {
      return this.popupConfig.formMode !== "review";
      // if (this.popupConfig.formMode === "review") return false;
      // else if (this.popupConfig.formMode !== "create" && this.dataModel.FriendlyStatus === "In Production")
      //   return false;
      // else return true;
    },

    getTotalAddInQty() {
      return this.addInDataSource._array.reduce(
        (prev, curr) => prev + curr.AddInStockUMQty,
        0.0,
      );
    },

    // Header Updates
    getHeaderSection2Columns() {
      return [
        {
          caption: "",
          dataField: "Title",
          minWidth: 120,
          allowSorting: false,
        },
        {
          alignment: "right",
          caption: this.ProductionSummary.StockUM
            ? `Quantity (${this.ProductionSummary.StockUM})`
            : "Quantity (UM)",
          dataField: "StockUMQty",
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          width: ColumnWidth.Quantity4DecimalPoints.width,
          format: "##,###,###,###,##0.0000;(##,###,###,###,##0.0000)",
          cellTemplate: (data, info) => {
            if (info.rowIndex === 5) {
              return (data.innerHTML = `<div class='variance-template ${
                info.data.VarianceStockUMQty < 0 ? "negative" : ""
              }''>${formatNumber(
                info.data.VarianceStockUMQty,
                "##,###,###,###,##0.0000;(##,###,###,###,##0.0000)",
              )}</div>`);
            } else if (
              info.rowIndex === 6 &&
              this.WorkOrderInstance === "Core"
            ) {
              return (data.innerHTML = `<div class='variance-percent-template ${
                info.data.VarianceProductionUMPercent < 0 ? "negative" : ""
              }''>${formatNumber(
                info.data.VarianceProductionUMPercent,
                "###,###,##0.00 '%';(###,###,##0.00 '%')",
              )}</div>`);
            } else {
              return (data.innerHTML = `<div class='comment-cell-template'>${info.text}</div>`);
            }
          },
          allowSorting: false,
        },
        {
          alignment: "right",
          caption: this.ProductionSummary.ProductionUM
            ? `Quantity (${this.ProductionSummary.ProductionUM})`
            : "Quantity (UM)",
          dataField: "ProductionUMQty",
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          width: ColumnWidth.Quantity4DecimalPoints.width,
          format: "##,###,###,###,##0.0000;(##,###,###,###,##0.0000)",
          cellTemplate: (data, info) => {
            if (info.rowIndex === 5) {
              return (data.innerHTML = `<div class='variance-template ${
                info.data.VarianceProductionUMQty < 0 ? "negative" : ""
              }'>${formatNumber(
                info.data.VarianceProductionUMQty,
                "##,###,###,###,##0.0000;(##,###,###,###,##0.0000)",
              )}</div>`);
            } else if (
              info.rowIndex === 6 &&
              this.WorkOrderInstance === "Core"
            ) {
              return (data.innerHTML = `<div class='variance-percent-template ${
                info.data.VarianceProductionUMPercent < 0 ? "negative" : ""
              }'>${formatNumber(
                info.data.VarianceProductionUMPercent,
                "###,###,##0.00 '%';(###,###,##0.00 '%')",
              )}</div>`);
            } else {
              return (data.innerHTML = `<div class='comment-cell-template'>${info.text}</div>`);
            }
          },
          allowSorting: false,
        },
      ];
    },
    getHeaderSection2DataSource() {
      return this.headerSection2DataSource._array;
    },

    getHeaderSection3Columns() {
      return this.WorkOrderInstance === "Almondco"
        ? [
            {
              caption: "Totals",
              dataField: "Title",
              minWidth: 110,
              allowSorting: false,
            },
            {
              caption: this.MaterialSummary.StockUM
                ? `Weight (${this.MaterialSummary.StockUM})`
                : "Weight (UM)",
              dataField: "Weight",
              minWidth: ColumnWidth.Quantity2DecimalPoints.minWidth,
              width: ColumnWidth.Quantity2DecimalPoints.width,
              format: "##,###,###,###,##0.0000;(##,###,###,###,##0.0000)",
              allowSorting: false,
            },
            {
              caption: " ",
              dataField: "Value",
              minWidth: ColumnWidth.Quantity2DecimalPoints.minWidth,
              width: ColumnWidth.Quantity2DecimalPoints.width,
              format: "###,###,##0.00 '%';(###,###,##0.00 '%')",
              allowSorting: false,
            },
          ]
        : [
            {
              caption: "Work Order Costs",
              dataField: "Title",
              minWidth: 115,
              allowSorting: false,
            },
            {
              caption: "Planned",
              dataField: "PlannedCost",
              minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
              width: ColumnWidth.Quantity4DecimalPoints.width,
              format: "##,###,###,###,##0.0000;(##,###,###,###,##0.0000)",
              allowSorting: false,
            },
            {
              caption: "Actual",
              dataField: "ActualCost",
              minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
              width: ColumnWidth.Quantity4DecimalPoints.width,
              format: "##,###,###,###,##0.0000;(##,###,###,###,##0.0000)",
              allowSorting: false,
            },
            {
              caption: "Variance",
              dataField: "Variance",
              minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
              width: ColumnWidth.Quantity4DecimalPoints.width,
              format: "##,###,###,###,##0.0000;(##,###,###,###,##0.0000)",
              allowSorting: false,
            },
            {
              caption: "",
              dataField: "VariancePercentage",
              minWidth: ColumnWidth.WorkOrderPercentage.minWidth,
              width: ColumnWidth.WorkOrderPercentage.width,
              format: "###,###,##0.00 '%';(###,###,##0.00 '%')",
              allowSorting: false,
            },
          ];
    },
    getHeaderSection3Part2Columns() {
      return [
        {
          caption: "Unit Costs",
          dataField: "Title",
          minWidth: 115,
          allowSorting: false,
        },
        {
          caption: "Planned",
          dataField: "PlannedCost",
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          width: ColumnWidth.Quantity4DecimalPoints.width,
          format: "##,###,###,###,##0.0000;(##,###,###,###,##0.0000)",
          allowSorting: false,
        },
        {
          caption: "Actual",
          dataField: "ActualCost",
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          width: ColumnWidth.Quantity4DecimalPoints.width,
          format: "##,###,###,###,##0.0000;(##,###,###,###,##0.0000)",
          allowSorting: false,
        },
        {
          caption: "Variance",
          dataField: "Variance",
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          width: ColumnWidth.Quantity4DecimalPoints.width,
          format: "##,###,###,###,##0.0000;(##,###,###,###,##0.0000)",
          allowSorting: false,
        },
        {
          caption: "",
          dataField: "VariancePercentage",
          minWidth: ColumnWidth.WorkOrderPercentage.minWidth,
          width: ColumnWidth.WorkOrderPercentage.width,
          format: "###,###,##0.00 '%';(###,###,##0.00 '%')",
          allowSorting: false,
        },
      ];
    },
    getHeaderSection3DataSource() {
      return this.headerSection3DataSource._array;
    },
    getHeaderSection3Part2DataSource() {
      return this.headerSection3Part2DataSource._array;
    },
  },
  watch: {
    getHotKeySave: {
      handler(val) {
        if (val && this.HotKeyWatcherEnabled) {
          this.$store.dispatch("hotKey/setHotKeySave", false);
          if (this.popupConfig.formMode !== "review") {
            this.onSavePopupHandler();
          }
        }
      },
      deep: true,
    },
    mtsDataSource: {
      handler(val) {
        this.model.MTSQuantity = val._array.reduce(
          (total, element) => total + element.StockUMQuantity,
          0,
        );
        this.model.Quantity = this.model.MTSQuantity + this.model.SOQuantity;

        if (this.popupConfig.formMode !== "review") {
          this.updateHeaderSection2Values();
        }
      },
      deep: true,
    },
    addInDataSource: {
      handler(val) {
        if (val) {
          if (this.popupConfig.formMode !== "review") {
            this.calculateAddInHeaderValues();
          }
        }
      },
      deep: true,
    },
    IsFormLoaded: {
      handler(val) {
        if (val) {
          setTimeout(() => {
            this.setModelItemHeights();
          }, 500);
        }
      },
      immediate: true,
    },
  },
};
</script>
<style lang="scss">
.gc-popup-work-order {
  .hyperlink.negative a {
    color: red !important;
  }

  .hyperlink.zero a {
    color: black !important;
  }
  .status-template {
    display: flex;
    align-items: center;
  }
  .dx-toolbar.dx-popup-title {
    height: 60px;
  }

  .toolbar-title-secondary {
    padding-left: unset !important;
    font-weight: 400;
    font-size: 14px;
  }

  .wo-data-details {
    background-color: unset !important;
    margin: 0px 10px;
    padding-top: 10px;

    .wo-so-toolbar {
      .add-new-btn {
        .dx-button {
          background-color: unset !important;
          .dx-button-content .dx-icon::before {
            color: #344054 !important;
          }

          .dx-button-text {
            padding-right: unset !important;
          }
        }

        margin-right: 10px;
        background: var(
          --Component-colors-Components-Buttons-Secondary-button-secondary-bg,
          #ffffff
        );
        border: 1px solid
          var(
            --Component-colors-Components-Buttons-Secondary-button-secondary-border,
            #d0d5dd
          );
        box-shadow: 0px 1px 2px 0px #1018280d;

        .dx-icon.dx-icon-plus::before {
          color: #344054 !important;
        }

        .dx-button-text {
          font-family: Inter;
          font-weight: 600;
          font-size: 12px;
          // line-height: 20px;
          letter-spacing: 0%;
          color: var(
            --Component-colors-Components-Buttons-Secondary-button-secondary-fg,
            #344054
          );
        }
      }
    }
  }

  .wo-so-lines {
    .dx-datagrid-header-panel {
      height: 0px !important;
    }
  }
  .wo-materials-grid {
    .dx-datagrid-checkbox-size {
      vertical-align: top !important;
    }
  }

  .dx-datagrid
    .dx-datagrid-content
    .dx-datagrid-table
    .dx-row
    > td:not(.dx-validation-pending):not(.dx-datagrid-select-all) {
    vertical-align: top !important;
  }

  .dx-datagrid
    .dx-datagrid-content
    .dx-datagrid-table
    .dx-row
    > td:first-of-type:not(.dx-command-expand) {
    padding-left: 10px !important;
  }

  .dx-datagrid
    .dx-datagrid-content
    .dx-datagrid-table
    .dx-row
    .dx-command-select.dx-editor-cell {
    padding-left: 5px !important;
    padding-right: 5px !important;
  }

  .process-code {
    padding-left: 10px !important;
  }

  .os-qty {
    padding-right: 10px !important;
  }

  .dx-datagrid
    .dx-datagrid-content
    .dx-datagrid-table
    .dx-row
    .dx-editor-cell.dx-focused {
    padding-right: 5px !important;
    padding-left: 5px !important;
  }

  .wo-data-header {
    background-color: white;
    padding: 12px;
    display: flex;
    justify-content: space-between;
    gap: 10px;

    > div {
      // width: 100%;

      .dx-datagrid-header-panel {
        height: 0px !important;
      }

      .dx-scrollable-wrapper > .dx-scrollable-container {
        overflow-y: hidden !important;
      }
    }

    .section-1 {
      width: 40%;

      // overflow: hidden;
      -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12),
        0 1px 2px rgba(0, 0, 0, 0.24);
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
      border-radius: 2px;
      background-color: #fff;
    }

    .section-2,
    .section-3 {
      width: 30%;

      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }

    .header-section-3-part2-grid {
      .dx-header-row {
        td {
          height: 35px !important;
          padding-top: 8px !important;
          padding-bottom: 8px !important;
        }
      }
    }
  }
  .variance-template,
  .variance-percent-template {
    color: green;

    &.negative {
      color: red;
    }
  }

  .wo-data-header.core-instance {
    .section-1 {
      width: 35% !important;
    }
    .section-2 {
      width: 25% !important;
    }

    .section-3 {
      width: 40% !important;
    }
  }

  .section-1 {
    border: 1px solid var(--Colors-Border-border-primary, #d0d5dd);
  }

  .expand-enter-active,
  .expand-leave-active {
    transition: all 0.5s ease;
    overflow: hidden;
  }

  .expand-enter,
  .expand-leave-to {
    opacity: 0;
    max-height: 0;
    transform: scaleY(0.95);
  }

  .expand-enter-to,
  .expand-leave {
    opacity: 1;
    max-height: 1000px; // adjust if form is larger
    transform: scaleY(1);
  }

  .gc-popup-form {
    padding-bottom: 0px !important;
  }
}
</style>
